{
  "brandName": "Dashbal",
  "loadingStates": {
    "fetching": "Fetching your data...",
    "organizing": "Organizing insights...",
    "analyzing": "Analyzing financials...",
    "syncing": "Synchronizing data...",
    "almost": "Almost there...",
    "finalizing": "Finalizing data flow..."
  },
  "navigation": {
    "home": "Boards",
    "boards": "Boards",
    "settings": "Settings",
    "profile": "Profile",
    "logout": "Logout",
    "recent": "Recent",
    "connectedChannels": "Connected Channels",
    "moneyJournal": "Money Journal",
    "confirmLogout": "Are you sure you want to logout?",
    "upgradePlan": "Upgrade Plan",
    "help": "Help"
  },
  "auth": {
    "login": "Login",
    "register": "Register",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "firstName": "First Name",
    "lastName": "Last Name",
    "name": "Name",
    "forgotPassword": "Forgot Password?",
    "noAccount": "Don't have an account?",
    "hasAccount": "Already have an account?",
    "signUp": "Sign Up",
    "signIn": "Sign In",
    "emailPlaceholder": "you@example.com",
    "passwordPlaceholder": "••••••••",
    "forgotPasswordTitle": "Forgot Password?",
    "forgotPasswordDescription": "Enter your email address and we'll send you a link to reset your password.",
    "sendResetLink": "Send Reset Link",
    "backToSignIn": "Back to Sign In",
    "checkYourEmail": "Check Your Email",
    "resetLinkSentTo": "We've sent a password reset link to:",
    "whatToDo": "What to do:",
    "openEmailInbox": "Open your email inbox",
    "clickResetLink": "Click the password reset link in the email",
    "createNewPassword": "Create a new secure password",
    "linkExpiresIn30": "The link will expire in 30 minutes for security.",
    "cantFindEmail": "Can't find the email? Check your spam folder.",
    "resetPasswordTitle": "Reset Password",
    "resetPasswordDescription": "Enter your new secure password below.",
    "newPassword": "New Password",
    "passwordRequirements": "Min 8 characters, letters & numbers required",
    "resetPassword": "Reset Password",
    "passwordMinLength": "Password must be at least 8 characters long.",
    "passwordRequireNumber": "Password must contain at least one number.",
    "passwordRequireLetter": "Password must contain at least one letter.",
    "passwordsDoNotMatch": "Passwords do not match.",
    "passwordResetSuccess": "Password Reset Successful!",
    "passwordResetSuccessMessage": "Your password has been updated successfully. You can now sign in with your new password.",
    "resetFailed": "We couldn't reset your password",
    "couldNotResetPassword": "We couldn't reset your password.",
    "thisCouldHappenIf": "This could happen if:",
    "linkExpired": "The reset link has expired",
    "linkAlreadyUsed": "The link was already used",
    "linkInvalid": "The link is invalid",
    "requestNewLink": "Request New Reset Link",
    "missingResetToken": "Reset Link Issue",
    "noTokenMessage": "No reset token was found in the URL. Please click the link in your email again, or request a new password reset.",
    "requestPasswordReset": "Request Password Reset",
    "continueWithEmail": "Continue with Email",
    "continueWithGoogle": "Continue with Google",
    "continueWithApple": "Continue with Apple",
    "continueWithFacebook": "Continue with Facebook",
    "continueWithTikTok": "Continue with TikTok",
    "socialLoginNotConfigured": "Social login is ready to be connected. Please configure OAuth credentials.",
    "registrationAgreement": "By signing up, you agree to our <0>Terms of Service</0> and <1>Privacy Policy</1>.",
    "verifyingEmail": "Verifying your email...",
    "emailVerified": "Email Verified!",
    "alreadyVerified": "Already Verified",
    "verificationFailed": "We couldn't verify your email",
    "verificationLinkExpired": "The verification link has expired. Please request a new one.",
    "verificationLinkUsed": "This verification link has already been used.",
    "verificationLinkInvalid": "The verification link is invalid.",
    "verificationNoToken": "Email confirmation issue",
    "verificationEmailSent": "Verification email sent! Check your inbox.",
    "resendEmailPrompt": "Didn't receive it? Resend Email",
    "cantFindEmailHelp": "Can't find the email? Check your spam folder or <0>use a different email address</0>.",
    "resendIn": "Resend in {{seconds}}s",
    "requestNewVerification": "Request New Verification Email",
    "signInToResend": "Sign In to Resend",
    "resetPasswordError": "Failed to reset password. The token may have expired.",
    "copyright": "© {{year}} Dashbal. All rights reserved.",
    "securingConnection": "Securing Connection",
    "connectionSuccessful": "Success!",
    "connectionFailed": "Connection Failed",
    "verifyingWithProvider": "Verifying your {{provider}} account...",
    "redirecting": "Awesome! We're redirecting you now...",
    "socialLoginError": "We couldn't verify your identity. Please try again.",
    "pleaseWaitVerifying": "Please wait while we verify your email address.",
    "emailVerifiedSuccess": "Your email has been verified successfully.",
    "accountActivated": "Your account is now fully activated. You can start using all Dashbal features.",
    "alreadyVerifiedMessage": "Your email address has already been verified. You",
    "noVerificationTokenMessage": "No verification token was found in the URL. Please click the link in your email again, or request a new verification email.",
    "goToLogin": "Go to Login",
    "welcomeToDashbal": "Welcome to Dashbal",
    "welcomeWithName": "Welcome to Dashbal, {{name}}!",
    "or": "or",
    "useMagicLink": "Sign in with magic link",
    "sendMagicLink": "Send magic link",
    "magicLinkDescription": "Enter your email and we'll send you a secure sign-in link. No password needed.",
    "magicLinkSentTo": "We've sent a sign-in link to:",
    "magicLinkExpiry": "The link will expire in 15 minutes.",
    "magicLinkSendError": "We couldn't send the magic link. Please try again.",
    "resendMagicLink": "Send again",
    "magicLinkVerifying": "Signing you in...",
    "magicLinkPleaseWait": "Please wait while we verify your magic link.",
    "magicLinkSuccess": "You're signed in!",
    "magicLinkRedirecting": "Redirecting you to your dashboard...",
    "magicLinkFailed": "Sign-in failed",
    "magicLinkExpired": "This magic link has expired. Please request a new one.",
    "magicLinkInvalid": "This magic link is invalid or has already been used.",
    "magicLinkVerifyError": "We couldn't verify your magic link. Please try again.",
    "magicLinkNoToken": "No magic link token found. Please click the link in your email again."
  },
  "boards": {
    "title": "Boards",
    "subtitle": "Manage your boards and track financial data",
    "createBoard": "Create Board",
    "boardName": "Board Name",
    "boardDescription": "Board Description",
    "noBoards": "No boards yet",
    "createFirstBoard": "Create your first board to get started",
    "name": "Name",
    "lastModified": "Modified",
    "owner": "Owner",
    "you": "You",
    "list": "List",
    "grid": "Grid",
    "lastUpdated": "Last updated",
    "deleteBoard": "Delete Board",
    "editBoard": "Edit Board",
    "duplicateBoard": "Duplicate Board",
    "returnToBoard": "Return to Board",
    "returnToBoardConfirm": "You'll be redirected back to {{boardName}} shortly.",
    "returnNow": "Return Now",
    "confirmDelete": "Are you sure you want to delete this board?",
    "deleteConfirm": "Are you sure you want to delete this board?",
    "confirmRemoveChannel": "Are you sure you want to remove this channel? It will be removed from the board along with all its data.",
    "confirmRemoveJournal": "Are you sure you want to remove this journal from the board?",
    "deleteWarning": "This action cannot be undone.",
    "alerts": {
      "editModeTitle": "Edit Mode",
      "editModeMessage": "Please save or cancel changes before switching pages.",
      "deletePageTitle": "Delete Page",
      "deletePageMessage": "Are you sure you want to delete this page?",
      "deletePageError": "Failed to delete page",
      "reorderPagesError": "Failed to reorder pages"
    },
    "ai": {
      "title": "AI Tasks",
      "processing": "AI is currently processing your request...",
      "processingStatus": "Processing...",
      "interruptedStatus": "Interrupted",
      "completedStatus": "Completed",
      "backToHistory": "Back to History",
      "promptPlaceholder": "Ask AI to help with your board...",
      "messagePlaceholder": "Message AI...",
      "history": "History",
      "resumingConversation": "Resuming conversation about: \"{{prompt}}\". How can I help you further with this?",
      "status": {
        "processing": "Processing...",
        "interrupted": "Interrupted",
        "completed": "Completed",
        "executingTask": "Executing task: {{task}}...",
        "executionStarted": "Execution started...",
        "executionFailed": "We couldn't complete the tasks.",
        "executionComplete": "Execution complete.",
        "executionCancelled": "I will not execute these tasks."
      },
      "stopTask": "Stop task",
      "deleteConversation": "Delete conversation",
      "hideReview": "Hide Review",
      "reviewTasks": "Review Tasks",
      "reviewTasksTitle": "Review Tasks",
      "selectTasksDescription": "Please select the tasks you want the AI to execute:",
      "validateExecute": "Validate & Execute",
      "acceptedTasksTitle": "Completed Tasks",
      "acceptedTasksDescription": "These actions were applied automatically. They are shown here for visibility.",
      "acceptedTasksMessage": "I've completed the following actions on your behalf.",
      "acceptedSection": "Already Done",
      "pendingSection": "Awaiting Approval",
      "taskDone": "Done",
      "taskFailed": "Failed",
      "viewAcceptedTasks": "View completed tasks",
      "hideAcceptedTasks": "Hide tasks",
      "confirmDeleteTitle": "Delete Conversation?",
      "confirmDeleteMessage": "Are you sure you want to delete this conversation about \"{{prompt}}\"? This action cannot be undone.",
      "mock": {
        "approvalMessage": "I have analyzed your request and prepared the following tasks to execute. Please review and approve them.",
        "executedMessage": "Tasks have been successfully executed.",
        "generalAnalysis": "I've analyzed your board based on your request: \"{{prompt}}\".\n\n- The data indicates consistent performance.\n- There are no major anomalies in recent data.\n- Let me know if you need specific visualizations.",
        "task1": "Create a new revenue chart for Q3",
        "task2": "Update the currency exchange rates to latest",
        "task3": "Delete redundant expense entries in Channel A"
      },
      "quotaExceeded": "You've reached your weekly AI quota limit. Your capacity will begin to reset **{{resetTime}}**.",
      "errorMessage": "Sorry, I ran into an error processing your request.",
      "retry": "Retry",
      "responses": {
        "followUpActions": "I",
        "followUpAnalysis": "I"
      }
    },
    "boardRenamed": "Board renamed successfully",
    "renameBoard": "Rename Board",
    "connections": "Connected Data Sources",
    "connectionsDescription": "Data sources linked to this board. Click to manage selections.",
    "noConnections": "No connections yet. Click + to add sources.",
    "noConnectionsConnect": "Connect a channel to start analysing your data.",
    "noConnectionsSelect": "Select data from your connected channels.",
    "content": "Financial Inputs",
    "noContent": "No inputs yet",
    "noContentDescription": "Connect financial inputs to unlock insights and analysis.",
    "addContent": "Add Input",
    "emptyBoardTitle": "Start Building Your Board",
    "emptyBoardDescription": "You don't have any pages yet. Create a page from a template to get started visualizing your data.",
    "createPageFromTemplate": "Create Page from Template",
    "templates": "Templates",
    "addPage": "Add Page",
    "createPage": "Create Page",
    "addCharts": "Add Charts",
    "emptyStateNoDataTitle": "Connect Your Data",
    "emptyStateNoDataDescription": "Connect your channels or add journals to start visualizing your finance.",
    "connectData": "Connect Data",
    "savePageAsTemplate": "Save Page as Template",
    "boardCenterpiece": "All data sources connected to this board",
    "addConnection": "Add Connection",
    "addConnectionDescription": "Connect a data source to get started",
    "boardNameUpdated": "Board name updated successfully",
    "addConnectionType": "Add Connection",
    "connectedChannel": "Connected Channel",
    "connectedChannelDescription": "Link data from your connected platforms",
    "saveAsTemplate": "Save as Template",
    "connectFirstChannel": "Connect a Channel",
    "connectFirstChannelDesc": "You need to connect a channel (like Plaid or Stripe) before you can add it to your board.",
    "createFirstJournal": "Create a Journal",
    "createFirstJournalDesc": "Money Journals help you track manual entries and cash flow.",
    "moneyJournal": "Money Journal",
    "moneyJournalDescription": "Add operations from your journals",
    "selectChannelSource": "Select Channel Source",
    "selectChannelSourceDescription": "Choose from your connected channels or add a new one",
    "selectFromExisting": "Select from Existing",
    "selectFromExistingChannels": "Choose from connected channels",
    "addNewChannelDescription": "Connect a new platform",
    "selectJournalSource": "Select Journal Source",
    "selectJournalSourceDescription": "Choose from existing journals or create a new one",
    "selectFromExistingJournals": "Choose from existing journals",
    "addNewJournal": "Add New Journal",
    "addNewJournalDescription": "Create a new money journal",
    "selectChannel": "Select Channel",
    "selectChannelToAdd": "Choose a channel to add to your board",
    "noAvailableChannels": "No available channels to add",
    "selectJournal": "Select Journal",
    "selectJournalToAdd": "Choose a journal to add to your board",
    "noAvailableJournals": "No available journals to add",
    "quitBoardTitle": "Quit Board?",
    "quitBoardMessage": "You are about to leave the current board. Any unsaved layout changes will be lost.",
    "manageJournalsTitle": "Go to Journals Library",
    "manageJournalsMessage": "To add a new money journal, you need to navigate to your journal library for a moment. Don't worry, you can easily come back to your board afterward.",
    "manageJournalsConfirm": "Go to Journals",
    "unsavedChangesAlert": "You have unsaved changes. Are you sure you want to leave?",
    "backToExplorer": "Back to Explorer",
    "quitBoardToManageChannelsMessage": "You are about to leave the current board to manage your connected channels. Any unsaved layout changes will be lost.",
    "loadingFinance": "Loading financial data...",
    "financeError": "We're having trouble loading your data",
    "noFinanceData": "No financial data available",
    "selectItemsHint": "Select items and a date range to view the waterfall chart",
    "loadingTemplates": "Loading templates...",
    "missingConnection": "Missing connection",
    "connectedData": "Connected Data",
    "addToBoard": "Add to Board",
    "layout": {
      "title": "Board Layout",
      "description": "Configure your layout with charts and components. Supports responsive grid layouts and smooth animations."
    },
    "disconnectedWarning": "This channel is disconnected. The board will not be able to fetch new data from it.",
    "viewConnections": "View Connections",
    "connectionsCount": "{{count}} {{name}} connection",
    "connectionsCount_plural": "{{count}} {{name}} connections",
    "journalsCount": "{{count}} Journal",
    "journalsCount_plural": "{{count}} Journals",
    "specsCount": "{{count}} Board Spec",
    "specsCount_plural": "{{count}} Board Specs",
    "boardSpec": "Board Spec",
    "backTo": "Back to",
    "board": "Board",
    "viewNotice": "View Notice",
    "tips": {
      "connectSources": "Connect Sources",
      "connectSourcesDesc": "The more channels you connect, the more powerful your automated financial insights become.",
      "moneyJournal": "Money Journal",
      "moneyJournalDesc": "Track manual expenses and cash-on-hand using the Money Journal to complete your financial picture.",
      "support": "Community & Support",
      "supportDesc": "Join our community of business owners or talk to our experts to get the most out of Dashbal."
    }
  },
  "boardSpecs": {
    "header": "Board Specs",
    "editTitle": "Edit Board Spec",
    "addTitle": "Add Board Spec",
    "specNameLabel": "Spec Name",
    "specNamePlaceholder": "e.g. VAT Payable, Income Tax",
    "formulaLabel": "Formula",
    "formulaPlaceholder": "Type a connection... (e.g. commerce.all.revenues)",
    "errorsTitle": "Errors",
    "cancel": "Cancel",
    "save": "Save Spec",
    "saving": "Saving...",
    "specNameRequired": "Spec name is required",
    "estimatedValue": "Estimated Value",
    "failedToSave": "We couldn't save your calculation",
    "types": {
      "channel": "channel",
      "journal": "journal",
      "item": "item",
      "category": "category",
      "special": "special"
    },
    "errors": {
      "empty": "Formula is empty",
      "unexpectedOperator": "Check your formula symbols",
      "endsInOperator": "Your formula shouldn't end with an operator",
      "invalidNumber": "Please check the numbers in your formula",
      "numberEndsInDot": "Numbers cannot end with a dot",
      "invalidChar": "We found an unrecognized character in your formula",
      "endsInDot": "Formula cannot end with a dot",
      "unbalancedParenthesis": "Check your opening and closing parentheses",
      "doubleDots": "Double dots are not allowed",
      "invalidSyntaxTerminal": "The formula needs to end with a valid value",
      "incompleteAll": "Incomplete reference: all. Expected category",
      "incompleteCategory": "Incomplete category",
      "invalidCategory": "Invalid category: {{value}}",
      "allFollowedByCategory": "'all' keyword should be followed directly by category",
      "unknownConnection": "Unknown connection: {{value}}",
      "onlyCategoryAfterAll": "Only a category can follow 'all'",
      "itemNotFound": "Item '{{item}}' not found under '{{parent}}'",
      "incompleteReference": "Incomplete reference",
      "expectedItemOrAll": "Incomplete reference: Expected item or all",
      "expectedCategoryAtEnd": "Expected category at the end",
      "incompleteReferenceExpectedCategory": "Incomplete reference. Expected category.",
      "invalidItemOrCategory": "We couldn't find that item or category"
    },
    "addSpec": "Add Spec"
  },
  "featureExplanation": {
    "subtitle": "Understanding the flow",
    "connections": {
      "title": "Board Connections",
      "description": "Connect multiple data sources like Shopify or Meta. The board aggregates data from all your connections and transforms it into a unified, actionable dataset."
    },
    "specs": {
      "title": "Board Specs",
      "description": "A board spec is a formula that transforms connected data into new derived values, creating an additional data stream that is linked to the board alongside the original source."
    },
    "connection": {
      "label": "Connection"
    },
    "spec": {
      "label": "Spec"
    },
    "board": {
      "label": "Board"
    },
    "liveSource": "Live Source"
  },
  "charts": {
    "currentlyUnavailable": "This chart is currently unavailable",
    "addCharts": "Add Charts",
    "shipping": "Shipping Revenue",
    "shippingPerOrder": "Shipping Revenue/Order",
    "categories": {
      "all": "All",
      "financial": "Financial",
      "decision": "Decision",
      "operations": "Operations",
      "marketing": "Marketing",
      "growth": "Growth",
      "customerBehavior": "Customer Behavior",
      "prediction": "Prediction",
      "risk": "Risk",
      "expert": "Expert",
      "other": "Other"
    },
    "titles": {
      "total_revenue": "Total Revenue",
      "total_expenses": "Total Expenses",
      "net_profit_kpi": "Net Profit",
      "orders_kpi": "Orders",
      "ad_spend_kpi": "Ad Spend",
      "aov_kpi": "Average Order Value",
      "net_profit_over_time": "Net Profit Over Time",
      "profit_waterfall": "Profit Waterfall",
      "profit_margin_over_time": "Profit Margin % Over Time",
      "income_vs_costs": "Income vs Costs",
      "daily_pl_table": "Daily P&L Table",
      "running_profit": "Running Profit",
      "profit_period_comparison": "Profit: This Period vs Last",
      "roas_by_platform": "ROAS by Platform",
      "roas_over_time": "ROAS Over Time",
      "blended_mer": "Marketing Efficiency (MER)",
      "ad_spend_percent": "Ad Spend as % of Revenue",
      "cpa_over_time": "Cost per Order Over Time",
      "campaign_roas_leaderboard": "Campaign Profitability Ranking",
      "ad_set_efficiency_scatter": "Ad Set Efficiency Map",
      "creative_performance_table": "Creative Performance Table",
      "ad_funnel": "Ad Funnel: Views → Clicks → Orders",
      "cpm_trend": "CPM Trend (Cost to Reach)",
      "cpc_trend": "Cost per Click Trend",
      "wasted_ad_spend": "Wasted Ad Spend",
      "ctr_over_time": "Click-Through Rate Over Time",
      "best_sellers_by_revenue": "Best Sellers by Revenue",
      "revenue_concentration": "Revenue Concentration (80/20)",
      "product_sales_trend": "Product Sales Trend",
      "units_sold_ranking": "Units Sold Ranking",
      "revenue_per_unit": "Revenue per Unit by Product",
      "product_return_rate": "Return Rate by Product",
      "refund_damage_by_product": "Refund Damage by Product",
      "product_channel_matrix": "Product × Channel Matrix",
      "expense_category_donut": "Expense Breakdown",
      "expense_category_trend": "Cost Category Trend",
      "payment_processing_fees": "Payment Processing Fees",
      "payment_fees_percent": "Payment Fees as % of Revenue",
      "shipping_cost_over_time": "Shipping Revenue Over Time",
      "shipping_per_order": "Average Shipping Revenue per Order",
      "discount_total_and_rate": "Discounts Given",
      "journal_expense_breakdown": "Custom Expense Breakdown",
      "journal_expenses_over_time": "Custom Expenses Over Time",
      "true_cost_per_order": "True Cost per Order",
      "expense_anomaly_detector": "Unusual Expense Spikes",
      "daily_inflows_outflows": "Daily Money In vs Out",
      "cumulative_cash_position": "Running Cash Balance",
      "ad_spend_vs_revenue_timing": "Ad Spend vs Revenue Timing",
      "weekly_cash_summary": "Weekly Cash Flow",
      "break_even_day": "Break-Even Day",
      "money_flow_sankey": "Money Flow Diagram",
      "return_rate_over_time": "Return Rate Over Time",
      "refund_amount_over_time": "Refund Amount Over Time",
      "refund_type_breakdown": "Refund Type Breakdown",
      "refund_true_cost": "True Cost of Refunds",
      "most_returned_products": "Most Returned Products",
      "paid_vs_organic_revenue": "Paid vs Organic Revenue",
      "paid_vs_organic_trend": "Paid vs Organic Trend",
      "revenue_by_utm_source": "Revenue by Traffic Source",
      "revenue_by_utm_campaign": "Revenue by Marketing Campaign",
      "unattributed_revenue": "Unattributed Revenue",
      "purchase_frequency": "Purchase Frequency",
      "top_customers_by_revenue": "Top Customers by Spend",
      "customer_concentration": "Customer Revenue Concentration",
      "new_vs_returning_revenue": "New vs Repeat Customer Revenue",
      "avg_revenue_per_customer": "Average Revenue per Customer",
      "revenue_period_comparison": "Revenue: This Period vs Last",
      "order_volume_over_time": "Order Volume Over Time",
      "aov_trend": "Average Order Value Trend",
      "revenue_vs_ad_spend_growth": "Revenue Growth vs Ad Spend Growth",
      "spend_vs_roas_scatter": "Spend vs Return Efficiency",
      "sales_by_day_of_week": "Sales by Day of Week",
      "revenue_forecast": "Revenue Forecast",
      "expense_forecast": "Expense Forecast",
      "profit_forecast": "Profit Forecast",
      "break_even_projection": "Break-Even Projection",
      "seasonal_index": "Best & Worst Performing Days",
      "what_if_simulator": "What-If Scenario",
      "activity_timeline": "Activity Timeline",
      "revenue_with_action_markers": "Revenue with Action Markers",
      "budget_change_impact": "Budget Change Impact",
      "budget_increase_efficiency": "Budget Increase Efficiency",
      "campaign_toggle_impact": "Campaign Launch & Pause Impact",
      "pause_resume_comparison": "Pause/Resume Performance",
      "creative_swap_performance": "Creative Swap Performance",
      "audience_change_impact": "Audience Change Impact",
      "ad_approval_tracker": "Ad Approval Tracker",
      "campaign_lifecycle": "Campaign Lifecycle View",
      "product_launch_performance": "Product Launch Performance",
      "product_removal_impact": "Product Removal Impact",
      "promo_discount_rule_impact": "Promotion & Discount Rule Impact",
      "refund_spike_analysis": "Refund Spike Analysis",
      "order_fulfillment_funnel": "Order Fulfillment Funnel",
      "cancellation_rate_over_time": "Cancellation Rate Over Time",
      "activity_volume_vs_revenue": "Activity Volume vs Revenue",
      "billing_issues_timeline": "Billing & Payment Issues",
      "action_breakdown_by_type": "Action Breakdown by Type",
      "before_after_any_action": "Before/After Any Action"
    },
    "descriptions": {
      "total_revenue": "Total income from all sources",
      "total_expenses": "Total costs across all categories",
      "net_profit_kpi": "Revenue minus all expenses",
      "orders_kpi": "Total order count",
      "ad_spend_kpi": "Total advertising spend",
      "aov_kpi": "Average revenue per order",
      "net_profit_over_time": "Daily profit after all costs",
      "profit_waterfall": "Step-by-step breakdown from gross sales to net profit",
      "profit_margin_over_time": "Daily margin percentage trend",
      "income_vs_costs": "Revenue line vs stacked expense categories",
      "daily_pl_table": "Day-by-day profit and loss breakdown",
      "running_profit": "Cumulative profit within the period",
      "profit_period_comparison": "Profit trend compared to previous period",
      "roas_by_platform": "Return on ad spend per advertising platform",
      "roas_over_time": "Daily return on ad spend trend",
      "blended_mer": "Total revenue divided by total ad spend",
      "ad_spend_percent": "How much of revenue goes to advertising",
      "cpa_over_time": "Daily cost to acquire one order",
      "campaign_roas_leaderboard": "Campaigns ranked by return on ad spend",
      "ad_set_efficiency_scatter": "Spend vs revenue per ad set",
      "creative_performance_table": "Ad-level metrics: spend, impressions, clicks, CTR, CPC, ROAS",
      "ad_funnel": "Conversion funnel from impressions to purchases",
      "cpm_trend": "Daily cost per 1,000 impressions",
      "cpc_trend": "Daily average cost per click",
      "wasted_ad_spend": "Ads with spend but zero conversions",
      "ctr_over_time": "Daily CTR trend",
      "best_sellers_by_revenue": "Top products ranked by total revenue",
      "revenue_concentration": "Product revenue Pareto analysis",
      "product_sales_trend": "Revenue per product over time",
      "units_sold_ranking": "Products ranked by quantity sold",
      "revenue_per_unit": "Average selling price per unit",
      "product_return_rate": "Which products get returned most",
      "refund_damage_by_product": "Products costing the most in refunds",
      "product_channel_matrix": "Revenue heatmap: products vs store channels",
      "expense_category_donut": "Proportional split of all costs",
      "expense_category_trend": "Each cost type stacked over time",
      "payment_processing_fees": "Shopify and payment gateway fees",
      "payment_fees_percent": "Fee processing cut relative to revenue",
      "shipping_cost_over_time": "Daily shipping revenue",
      "shipping_per_order": "Shipping revenue per order trend",
      "discount_total_and_rate": "Discount amounts and percentage of gross sales",
      "journal_expense_breakdown": "Manual expenses by category",
      "journal_expenses_over_time": "Journal and formula expenses trend",
      "true_cost_per_order": "All-in cost per order",
      "expense_anomaly_detector": "Days with abnormally high costs",
      "daily_inflows_outflows": "Revenue bars vs expense bars per day",
      "cumulative_cash_position": "Cumulative net from day 1 of the period",
      "ad_spend_vs_revenue_timing": "Cash timing gap between spending and earning",
      "weekly_cash_summary": "Total in, out, and net per week",
      "break_even_day": "When cumulative revenue first exceeded expenses",
      "money_flow_sankey": "Revenue sources to expense categories to net profit",
      "return_rate_over_time": "Daily percentage of orders returned",
      "refund_amount_over_time": "Daily total refund dollars",
      "refund_type_breakdown": "Full returns vs partial vs shipping refunds",
      "refund_true_cost": "Refund amount plus wasted ad spend",
      "most_returned_products": "Products with highest refund amounts",
      "paid_vs_organic_revenue": "Revenue split between paid and organic",
      "paid_vs_organic_trend": "Daily paid and organic revenue",
      "revenue_by_utm_source": "Which traffic sources drive revenue",
      "revenue_by_utm_campaign": "Revenue per UTM campaign",
      "unattributed_revenue": "Revenue with no traffic source",
      "purchase_frequency": "Customer order count distribution",
      "top_customers_by_revenue": "Highest-spending customers",
      "customer_concentration": "Revenue distribution across customers",
      "new_vs_returning_revenue": "Revenue from first-time vs returning buyers",
      "avg_revenue_per_customer": "Total revenue divided by unique customers",
      "revenue_period_comparison": "Daily revenue compared to previous period",
      "order_volume_over_time": "Daily order count trend",
      "aov_trend": "Daily AOV trend",
      "revenue_vs_ad_spend_growth": "Is revenue outpacing ad spend?",
      "spend_vs_roas_scatter": "Does more spending still work?",
      "sales_by_day_of_week": "When do your customers buy?",
      "revenue_forecast": "Projected revenue based on trends",
      "expense_forecast": "Projected costs forward",
      "profit_forecast": "Combined revenue and expense projections",
      "break_even_projection": "When will cumulative profit turn positive?",
      "seasonal_index": "Which days consistently over/under-perform",
      "what_if_simulator": "Simulate ad spend changes on profit",
      "activity_timeline": "All ad and product changes, color-coded",
      "revenue_with_action_markers": "Daily revenue with event annotations",
      "budget_change_impact": "Revenue before vs after budget changes",
      "budget_increase_efficiency": "Incremental ROAS on budget increases",
      "campaign_toggle_impact": "Revenue before vs after campaign status changes",
      "pause_resume_comparison": "Pre-pause vs post-resume performance",
      "creative_swap_performance": "CTR before vs after creative changes",
      "audience_change_impact": "CPM before vs after targeting changes",
      "ad_approval_tracker": "Approved vs rejected ad reviews",
      "campaign_lifecycle": "Full timeline per campaign",
      "product_launch_performance": "Revenue from newly published products",
      "product_removal_impact": "Revenue impact of removing products",
      "promo_discount_rule_impact": "Order volume before vs after promo changes",
      "refund_spike_analysis": "Orders vs refunds offset by shipping delay",
      "order_fulfillment_funnel": "Placed, confirmed, shipped",
      "cancellation_rate_over_time": "Daily percentage of orders cancelled",
      "activity_volume_vs_revenue": "Do more changes correlate with better results?",
      "billing_issues_timeline": "Ad platform billing events and failures",
      "action_breakdown_by_type": "How many changes by category",
      "before_after_any_action": "Aggregate revenue impact of all actions"
    },
    "noData": {
      "title": "No Data Available",
      "description": "We couldn't find any records for this specific analysis."
    },
    "components": {
      "week_number": "Week {{number}}",
      "weeks": "Weeks",
      "months": "Months",
      "moneyJournal": "Money Journal",
      "moneyJournals": "Money Journals",
      "connection": "Connection",
      "boardSpec": "Board Spec",
      "boardSpecs": "Board Specs",
      "categoriesHeading": "Categories",
      "totalCaps": "TOTAL",
      "periodTotalCaps": "PERIOD TOTAL",
      "ads": "Ads",
      "sales": "Sales",
      "netProfit": "Net Profit",
      "net_cash_flow": "Net Cash Flow",
      "marketing": "Marketing",
      "cogs": "COGS",
      "fees": "Fees",
      "runningTotal": "Running Total",
      "opex": "OpEx",
      "cashflowWaterfall": "Cash Flow Breakdown",
      "selected_items": "Selected items",
      "channels": "Channels",
      "items": "Items",
      "journals": "Journals",
      "specs": "Calculations",
      "all": "All",
      "noData": "No data available",
      "noTransactionData": "No data available",
      "aboutThisChart": "About this chart",
      "noCategoryData": "No category data available",
      "noRevenueData": "No revenue data available",
      "noFinancialData": "No financial data available",
      "noEventsRecorded": "No events recorded",
      "eventsWillAppear": "Events will appear here once they occur",
      "netCashFlow": "Net Cash Flow",
      "profitMargin": "Profit Margin",
      "revenue": "Revenue",
      "expenses": "Expenses",
      "net": "Net",
      "account": "Account",
      "returns": "Returns",
      "grossSales": "Gross Sales",
      "totalRevenue": "Total Revenue",
      "totalExpenses": "Total Expenses",
      "running": "Running",
      "discounts": "Discounts",
      "netSales": "Net Sales",
      "shipping": "Shipping Revenue",
      "shippingPerOrder": "Shipping Revenue/Order",
      "taxes": "Taxes",
      "less": "Less",
      "more": "More",
      "total": "Total",
      "avgPerDay": "Avg/Day",
      "transactions": "Records",
      "cumulative": "Cumulative",
      "overallAverage": "Overall Average",
      "avgRevenue": "Avg Revenue",
      "avgExpense": "Avg Expense",
      "acrossTransactions": "across {{count}} records",
      "revenueAvgComparison": "Revenue avg is {{percent}}% of expense avg",
      "discountsApplied": "Discounts Applied",
      "netAfterDiscounts": "Net After Discounts",
      "revenueRetention": "Revenue Retention",
      "discountRate": "Discount Rate",
      "comparisonOverview": "Comparison overview",
      "detailedAnalysis": "Detailed revenue and expense analysis",
      "adjustments": "Adjustments",
      "totalSales": "Total Sales",
      "visualizeFlow": "Visualize how money flows through your business",
      "percentOfGrossSales": "{{percent}}% of gross sales",
      "unknown": "Unknown",
      "profit": "Profit",
      "roasLabel": "Return on Ad Spend (ROAS)",
      "generatedPerDollar": "Revenue generated per dollar spent",
      "adSpend": "Ad Spend",
      "roasFooter": "For every {{symbol}}1 spent on ads, you generate {{symbol}}{{value}} in revenue",
      "noAdvertisingData": "No advertising data",
      "addAdSpend": "Add ad spend records to calculate ROAS",
      "reporting": {
        "advertising": "Advertising",
        "marketing": "Marketing",
        "platformFees": "Platform Fees",
        "paymentFees": "Payment Fees",
        "otherExpenses": "Other Expenses"
      },
      "noExpenseData": "No expense data",
      "expensesAppearOnceAvailable": "Expenses will appear here once available",
      "dailyCumulativeTrends": "Daily cumulative trends",
      "financialFlowWithMarkers": "Financial flow with event markers",
      "netFlow": "Net Flow",
      "eventCount": "Event Count",
      "eventImpactFooter": "Purple bars show event activity. Hover to see event details and their impact on cash flow.",
      "status": {
        "excellent": "Excellent",
        "good": "Good",
        "moderate": "Moderate",
        "high": "High",
        "breakEven": "Break Even",
        "poor": "Poor"
      },
      "source": {
        "manual": "Manual Entry",
        "unknown": "Unknown"
      },
      "unableToDisplay": "Unable to Display Chart",
      "chartLoadError": "This chart couldn't be loaded. Please try refreshing the page.",
      "reloadPage": "Reload Page",
      "removeChart": "Remove Chart",
      "cohort": "Cohort",
      "monthN": "Month {{n}}",
      "cohortFooter": "Darker colors indicate higher revenue. Track how customer cohorts generate revenue over time.",
      "before": "Before",
      "during": "During",
      "after": "After",
      "addEventsForROI": "Add events to calculate ROI",
      "addEventsForAnalysis": "Add events to analyze revenue impact",
      "sunday": "Sunday",
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "bestDay": "Best Day",
      "worstDay": "Slowest Day",
      "noMarketingData": "No marketing data available",
      "addMarketingExpenses": "Add marketing or advertising expenses to track CAC",
      "avgCAC": "Avg CAC",
      "newCustomers": "New Customers",
      "avgMargin": "Avg Margin",
      "marginDropsDetected": "{{count}} significant margin drops detected",
      "weeklyTrend": "Weekly Trend",
      "velocityExplainer": "7-day rolling average of daily revenue",
      "eventMarkers": "Event markers",
      "dailyAvgRevenue": "Daily Avg Revenue",
      "anomaliesDetected": "anomalies detected",
      "anomalies": "Anomalies",
      "normal": "Normal",
      "anomaly": "Anomaly",
      "average": "Average",
      "noPromotionEvents": "No promotion events recorded",
      "addPromotionEvents": "Add promotion or campaign events to analyze effectiveness",
      "revenueLift": "Revenue Lift",
      "promotionFooter": "Compares average daily revenue before and after each promotion",
      "breakEvenReached": "Break-even reached",
      "projectedBreakEven": "Projected break-even",
      "notYetBreakEven": "Not yet at break-even",
      "cumulativeRevenue": "Cumulative Revenue",
      "cumulativeExpenses": "Cumulative Expenses",
      "netPosition": "Net Position",
      "attributionFooter": "Revenue attributed to each channel based on data source",
      "insufficientData": "Insufficient data for forecast",
      "needMoreHistory": "At least 2 weeks of expense history required",
      "trendIncreasing": "Expenses increasing",
      "trendDecreasing": "Expenses decreasing",
      "trendStable": "Expenses stable",
      "actual": "Actual",
      "forecast": "Forecast",
      "upper": "Upper",
      "lower": "Lower",
      "topEventType": "Top Event Type",
      "avgRevenuePerEvent": "Avg Revenue per Event",
      "revenuePerEventFooter": "Average revenue in the 3 days following each event type",
      "lift": "Lift",
      "drop": "Drop",
      "noChange": "No Change",
      "impactByActionType": "Impact by Action Type",
      "averageLift": "Average Lift",
      "metricCTR": "CTR",
      "metricCPC": "CPC",
      "metricROAS": "ROAS",
      "metricRevenue": "Revenue",
      "metricOrders": "Orders",
      "metricProfit": "Profit",
      "margin": "Margin",
      "forecastedGrowth": "Forecasted growth",
      "need14Days": "At least 14 days of data required",
      "need21Days": "At least 21 days of data required",
      "needMonthlyData": "At least 2 months of data required",
      "next14Days": "Next 14 days",
      "expected": "Expected",
      "worstCase": "Worst case",
      "bestCase": "Best case",
      "confidence": "Confidence",
      "simulationCount": "{{count}} simulations",
      "both": "Both",
      "linear": "Linear",
      "polynomial": "Polynomial",
      "bestFit": "Best fit",
      "regressionExplainer": "Higher R² indicates better fit. Dashed lines show forecasted values.",
      "trend": "Trend",
      "seasonal": "Seasonal",
      "residual": "Residual",
      "weightedCAC": "Weighted CAC",
      "cacLimit": "CAC Limit",
      "forecastAccuracy": "Forecast Accuracy",
      "attributionModel": "Attribution Model",
      "trendChange": "Trend change",
      "seasonalVariation": "Seasonal variation",
      "seasonalIndex": "Seasonal Index",
      "seasonalIndexExplainer": "Bars above 0% indicate above-average days, below 0% indicate below-average days.",
      "monthlyGrowth": "Monthly Growth",
      "expenseRatio": "Expense Ratio",
      "projectedRevenue6M": "6M Revenue",
      "projectedProfit6M": "6M Profit",
      "anomaliesFound": "anomalies found",
      "baseline": "Baseline",
      "zScoreThreshold": "Z-Score threshold",
      "accuracy": "Accuracy",
      "strong": "Strong",
      "weak": "Weak",
      "low": "Low",
      "grossRevenue": "Gross Revenue",
      "erosion": "Erosion",
      "netContribution": "Net Contribution",
      "shippingLogistics": "Shipping & Logistics",
      "taxCompliance": "Tax & Compliance",
      "totalCommercialVolume": "Total Commercial Volume",
      "growth": "Growth",
      "sector": "Sector",
      "noSectorData": "No sector data available",
      "economicsRatio": "Unit Economics Ratio",
      "healthStatus": "Health Status",
      "efficientGrowth": "Efficient Growth",
      "highAcquisitionCost": "High Acquisition Cost",
      "costToAcquire": "Cost to Acquire",
      "ltvEst": "Lifetime Value (Est)",
      "estimatedRunway": "Estimated Runway",
      "riskLevel": "Risk Level",
      "healthy": "HEALTHY",
      "critical": "CRITICAL",
      "solvencyDisclaimer": "* Based on current monthly burn rate. Does not account for future investments or seasonality.",
      "marginIntegrityMap": "Margin Integrity Map",
      "leakageHighlight": "Highlighting high-impact erosion events (returns & discounts)",
      "volume": "Volume",
      "leakage": "Leakage",
      "highRisk": "High Risk",
      "moderate": "Moderate",
      "sizeIndicatesLeakage": "Size indicates leakage magnitude",
      "productAffinityHeatmap": "Product Affinity Heatmap",
      "affinityScore": "Affinity Score",
      "clusteringExplainer": "Likelihood of items being purchased together",
      "insufficientDataSolvency": "Insufficient data for solvency projection.",
      "marginDrop": "Margin Drop",
      "event": "Event",
      "week": "Week",
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun",
      "Variable Costs": "Variable Costs",
      "Contribution Margin": "Contribution Margin",
      "cumulativePct": "Cumulative %",
      "revenuePct": "Revenue %",
      "refunds": "Refunds",
      "avgLTV": "Avg LTV",
      "revIndex": "Revenue Index",
      "fixedIndex": "Fixed Cost Index",
      "mer": "MER",
      "channel": "Channel",
      "grossProfit": "Gross Profit",
      "contributionMargin": "Contribution Margin",
      "opEx": "Operating Expenses",
      "ebitda": "EBITDA"
    },
    "empty": {
      "title": "No charts in this category yet",
      "subtitle": "We're working on adding more charts soon!"
    },
    "syncInfo": "Charts sync automatically with your board data.",
    "searchPlaceholder": "Search charts...",
    "dragInstructions": "Drag and drop charts or click to add them instantly.",
    "dragToAdd": "Drag to add",
    "transactionCategories": {
      "partial_return": "Partial Return",
      "product_return": "Product Return",
      "shipping_refund": "Shipping Refund",
      "tax_refund": "Tax Refund"
    }
  },
  "templates": {
    "title": "Templates",
    "subtitle": "Choose a template to quickly set up your board page.",
    "emptyPage": "Empty Page",
    "emptyPageDescription": "Start with a blank canvas",
    "categories": {
      "all": "All",
      "financialInsights": "Financial Insights",
      "decisionSupport": "Decision Support",
      "operationalEfficiency": "Operational Efficiency",
      "customerBehavior": "Customer Behavior",
      "predictiveAnalytics": "Predictive Analytics",
      "riskManagement": "Risk Management",
      "other": "Other"
    },
    "empty": {
      "title": "No templates in this category",
      "subtitle": "Create your first template or try a different category."
    },
    "import": {
      "title": "Import Template",
      "dropHere": "Drop template file here",
      "clickToImport": "Click to import or drop file",
      "supportedFormats": "Supports .json template files"
    },
    "templateType": "Template Type",
    "selectType": "Select a type",
    "selectPageTypeTitle": "Select Page Type",
    "pageTypes": {
      "performance": "Performance",
      "performanceDescription": "Analyze and visualize your business performance metrics.",
      "forecast": "Forecast",
      "forecastDescription": "Predict future revenue and expenses using historical data.",
      "cashflow": "Cash Flow",
      "cashflowDescription": "Monitor money moving in and out of your business.",
      "composer": "Composer",
      "composerDescription": "Build custom views with specialized components.",
      "traffic": "Traffic",
      "trafficDescription": "Analyze money distribution and flow across your traffic sources."
    }
  },
  "connections": {
    "title": "Connections",
    "addConnection": "Add Connection",
    "connected": "Connected",
    "disconnected": "Disconnected",
    "connect": "Connect",
    "disconnect": "Disconnect",
    "testConnection": "Test Connection",
    "connectionStatus": "Connection Status",
    "syncNow": "Sync Now",
    "active": "Active",
    "syncing": "Syncing"
  },
  "channels": {
    "shopify": "Shopify",
    "meta": "Meta",
    "tiktok": "TikTok",
    "google": "Google",
    "woocommerce": "WooCommerce",
    "amazon": "Amazon",
    "channels": "Channels",
    "active": "Active",
    "inactive": "Inactive",
    "uninstalled": "Uninstalled",
    "partial": "Partial",
    "removeChannel": "Remove channel",
    "noElements": "No elements available",
    "noChannels": "No channels added",
    "addChannel": "Add Channel",
    "loadingChannels": "Loading channels...",
    "connect": "Connect",
    "connectChannel": "Connect a channel",
    "choosePlatform": "Choose a platform to connect and start importing your data",
    "backToChannels": "Back to channels",
    "connectShopify": "Connect to Shopify",
    "shopifyIntro": "Connect your Shopify store by installing our official app. This ensures a secure and automated sync of your orders and analytics.",
    "shopifyStage1": "Click 'Install Dashbal App' below to begin.",
    "shopifyStage2": "Log in to your Shopify store and approve permissions.",
    "shopifyStage3": "Sit back while we sync your data for the first time!",
    "installDashbalApp": "Install Dashbal App",
    "connectWooCommerce": "Connect WooCommerce Store",
    "wooIntro": "Connect your WooCommerce store by installing our dedicated WordPress plugin. This allows us to securely sync your orders and sales data.",
    "wooStep1": "Download the Dashbal Connector plugin using the button below.",
    "wooStep2": "Go to Plugins > Add New > Upload on your WordPress dashboard.",
    "wooStep3": "Activate the plugin and click 'Connect to Dashbal' to finalize.",
    "downloadPlugin": "Download Dashbal Plugin",
    "goToWooAdmin": "Go to WooCommerce API Settings",
    "fillAllFields": "Please fill in all fields",
    "connectStore": "Connect Store",
    "shopifyRelease1": "Enter your Shopify store URL",
    "shopifyRelease2": "Install the Dashbal app in your Shopify Admin",
    "shopifyRelease3": "Click \"Connect to Dashbal\" in the app",
    "shopUrl": "Store URL",
    "verifyingStore": "Verifying store...",
    "goToShopifyAdmin": "Go to Shopify Admin",
    "connectingTo": "Connecting to {{channel}}",
    "completeAuthorization": "Please complete the authorization in the popup window. This may take a moment...",
    "loadingChannelsModal": "Loading available channels...",
    "noChannelsAvailable": "No channels available",
    "contactSupport": "Please contact support to enable channels for your account.",
    "availablePlatforms": "Available Platforms",
    "clickToConnect": "Click on a platform to begin the connection process",
    "dataSecure": "Your data is encrypted and secure",
    "cancel": "Cancel",
    "connecting": "Connecting...",
    "enterShopUrlPlaceholder": "your-store.myshopify.com",
    "shopUrlHelper": "You can also enter your custom domain or just the subdomain (e.g., \"mystore\")",
    "popupBlocked": "Popup was blocked. Please allow popups for this site.",
    "failedToConnect": "Failed to connect channel",
    "oauthFailed": "We couldn't connect to your account",
    "myChannels": "My Channels",
    "selectOrAddChannel": "Select a connected channel or add a new one",
    "noChannelsYet": "No channels yet",
    "getStartedDescription": "Get started by connecting your first channel. Click the button below to add a channel.",
    "addFirstChannel": "Add Your First Channel",
    "channel": "Channel",
    "provideRequiredInfo": "Please provide the required information to connect",
    "deleteChannel": "Delete Channel",
    "syncing": "Syncing...",
    "error": "Error",
    "loadingEntities": "Loading items...",
    "loadingCampaigns": "Loading your campaigns...",
    "loadingCampaignsHint": "We're fetching details from your account. This may take a moment.",
    "noEntitiesFound": "No items found",
    "selectParentHint": "Select a parent from the previous tab",
    "retrySync": "Try Syncing Again",
    "failedToSync": "We couldn't sync your data",
    "disconnected": "Disconnected",
    "reconnect": "Reconnect",
    "status": "Status",
    "reloadInitiated": "Reload initiated. Channel data is being refetched.",
    "reloadFailed": "Failed to initiate reload.",
    "addedAt": "Connected on",
    "situation": "Current Situation",
    "actions": "Actions",
    "information": "Information",
    "whatToDo": "What is this channel used for?",
    "whatToDoDescription": "Link this source to your boards to start tracking its results. You can select specific items to include in your financial analysis and grow your business with data.",
    "whatToDoDescription_shopify": "Link your store to automatically import sales, products, and customer records. Use this data to build your financial boards and track your real profit.",
    "whatToDoDescription_meta": "Connect your ad account to sync spending and performance metrics. Use this data to track your results efficiency and optimize your marketing budget.",
    "whatToDoDescription_tiktok": "Connect your ads manager to sync campaign spending and performance. Use these records to analyze your marketing results and growth.",
    "whatToDoDescription_google": "Connect your Google Ads account to sync spending and performance metrics. Use this data to track your efficiency and optimize your budget.",
    "whatToDoDescription_woocommerce": "Connect your store to sync orders and product records across all your sites. Use this information to centralize your financial tracking.",
    "reload": "Reload Channel Data",
    "placeholders": {
      "storeUrl": "https://your-store.com",
      "shopifyUrl": "your-store.myshopify.com or your-store.com",
      "wooConsumerKey": "ck_...",
      "wooConsumerSecret": "cs_..."
    },
    "creditCard": "Credit Card",
    "selectChannel": "Select Channel"
  },
  "brandLogo": "https://cdn.dashbal.com/assets/logo_c8e03e54.svg",
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "remove": "Remove",
    "removeChannel": "Remove Channel",
    "removeJournal": "Remove Journal",
    "edit": "Edit",
    "download": "Download",
    "create": "Create",
    "addCharts": "Add Charts",
    "addOperation": "Add Operation",
    "update": "Update",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "loading": "Loading...",
    "creating": "Creating...",
    "search": "Search",
    "filter": "Filter",
    "sort": "Sort",
    "share": "Share",
    "rename": "Rename",
    "openMenu": "Open menu",
    "close": "Close",
    "done": "Done",
    "continue": "Quit Board",
    "refresh": "Refresh Dashboard",
    "adjustDateRange": "Adjust Date Range",
    "stay": "Stay",
    "addSelection": "Add Selection",
    "editing": "Editing",
    "discard": "Discard",
    "dismissAlert": "Dismiss alert",
    "gotIt": "Got it, thanks!",
    "import": "Import",
    "export": "Export",
    "tryAgain": "Try Again",
    "goHome": "Go to Homepage",
    "sending": "Sending...",
    "reload": "Reload",
    "goToDashboard": "Go to Dashboard",
    "deleting": "Deleting..."
  },
  "boardMainSpace": {
    "title": "Board Layout",
    "description": "This is the main container for your board content.",
    "features": "It handles scrolling, animations, and layout structure."
  },
  "time": {
    "today": "Today",
    "yesterday": "Yesterday",
    "daysAgo": "{{count}}d ago",
    "justNow": "Just now",
    "minsAgo": "{{count}}m ago",
    "hoursAgo": "{{count}}h ago",
    "mon": "Mon",
    "tue": "Tue",
    "wed": "Wed",
    "thu": "Thu",
    "fri": "Fri",
    "sat": "Sat",
    "sun": "Sun"
  },
  "errors": {
    "required": "This field is required",
    "invalidEmail": "Please enter a valid email address",
    "passwordTooShort": "Password must be at least 8 characters",
    "nameTooShort": "Name must be at least 2 characters",
    "confirmPassword": "Please confirm your password",
    "passwordsDontMatch": "Passwords don't match",
    "somethingWentWrong": "Something went wrong",
    "networkError": "Connection issue",
    "unauthorized": "Please sign in to continue",
    "forbidden": "You don't have permission to view this",
    "failedToLoadBoards": "Failed to load boards. Please try again later.",
    "failedToCreateBoard": "Failed to create board",
    "failedToUpdateBoard": "Failed to update board",
    "failedToDeleteBoard": "Failed to delete board",
    "failedToLoadChannel": "Failed to load channel data",
    "error": "Error",
    "pleaseEnterShopUrl": "Please enter your shop URL",
    "wooConnectFailed": "Failed to connect. Please check your credentials.",
    "wooConnectionError": "Connection failed. Please check your credentials.",
    "failedToUpdateItemSelection": "Failed to update selection, please retry",
    "failedToAddChannel": "Failed to add channel to board",
    "failedToRemoveChannel": "Failed to remove channel from board",
    "failedToCreateOperation": "Failed to create operation",
    "failedToDeleteOperation": "Failed to delete operation",
    "failedToDeletejournal": "Failed to delete journal",
    "noBoardId": "No board ID available",
    "failedToUpdateBoardName": "Failed to update board name",
    "channel": {
      "30": "Sync error. Please try again.",
      "31": "Source not responding. Please check your connection or the status of the external platform.",
      "32": "Unauthorized access to channel. Please re-authenticate.",
      "33": "We encountered a problem while syncing your data.",
      "34": "Partial data sync. Some information might be missing.",
      "35": "Rate limit exceeded. Please try again later.",
      "36": "Invalid credentials. Please disconnect and reconnect the channel.",
      "37": "We had trouble processing your data. Please contact support.",
      "38": "Resource not found on external platform."
    },
    "tryLater": "Please try again later",
    "connectionIssue": "There was a problem connecting to the server. Please check your internet connection.",
    "timeout": "Server took too long. Please try again.",
    "generic": "An error occurred",
    "failedToUpdateChannelStatus": "Failed to update channel status",
    "failedToUpdateJournalStatus": "Failed to update journal status",
    "failedToDeleteOperations": "Failed to delete operations",
    "failedToUpdateEntitySelection": "Failed to update selection. Please try again.",
    "failedToUpdateOperationSelection": "Failed to update operation selection. Please try again."
  },
  "userErrors": {
    "generic": {
      "title": "Something went wrong",
      "message": "We encountered an issue while processing your request. Please try again.",
      "action": "Try Again"
    },
    "serviceUnavailable": {
      "title": "Service Temporarily Unavailable",
      "message": "We're experiencing technical difficulties. Our team is working on it. Please try again in a few moments.",
      "action": "Retry"
    },
    "networkError": {
      "title": "Connection Issue",
      "message": "Please check your internet connection and try again.",
      "action": "Retry"
    },
    "timeout": {
      "title": "Request Timeout",
      "message": "The request is taking longer than expected. Please try again.",
      "action": "Retry"
    },
    "rateLimit": {
      "title": "Too Many Requests",
      "message": "You've made too many requests. Please wait a moment before trying again.",
      "action": "Wait & Retry"
    },
    "sessionExpired": {
      "title": "Session Expired",
      "message": "Your session has expired. Please log in again to continue.",
      "action": "Log In"
    },
    "accessDenied": {
      "title": "Access Denied",
      "message": "You don't have permission to perform this action.",
      "action": "Go Back"
    },
    "notFound": {
      "title": "Not Found",
      "message": "The requested item could not be found.",
      "action": "Go Back"
    },
    "validation": {
      "title": "Invalid Input",
      "message": "Please check your information and try again.",
      "action": "Review"
    },
    "auth": {
      "invalidCredentials": "The email or password you entered is incorrect. If you forgot your password, you can reset it.",
      "accountNotFound": "We couldn't find an account with that email address. Would you like to create one?",
      "accountInactive": "Your account has been deactivated. Please contact support for assistance.",
      "emailAlreadyExists": "An account with this email address already exists. Try signing in instead.",
      "invalidResetToken": "The password reset link is invalid or has already been used.",
      "resetTokenExpired": "The password reset link has expired. Please request a new one.",
      "invalidCurrentPassword": "The current password you entered is incorrect.",
      "unableToSignIn": "We're having trouble signing you in. Please try again in a moment.",
      "unableToRegister": "We're having trouble creating your account. Please try again in a moment.",
      "signUpNow": "Sign Up Now",
      "signInInstead": "Sign In Instead",
      "resetPasswordLink": "Reset your password"
    },
    "boards": {
      "unableToCreate": "Unable to create your board. Please try again.",
      "unableToUpdate": "Unable to save your changes. Please try again.",
      "unableToDelete": "Unable to delete the board. Please try again.",
      "unableToLoad": "Unable to load your boards. Please refresh the page.",
      "unableToRename": "Unable to rename the board. Please try again."
    },
    "channels": {
      "unableToConnect": "Unable to connect to this channel. Please try again.",
      "unableToDisconnect": "Unable to disconnect the channel. Please try again.",
      "unableToLoad": "Unable to load channels. Please try again.",
      "unableToSync": "Unable to sync channel. Please try again.",
      "unableToDelete": "Unable to delete channel. Please try again.",
      "unableToRemove": "Unable to remove channel. Please try again."
    },
    "journals": {
      "unableToCreate": "Unable to create your journal. Please try again.",
      "unableToUpdate": "Unable to save your journal. Please try again.",
      "unableToDelete": "Unable to delete the journal. Please try again.",
      "unableToLoad": "Unable to load journals. Please try again.",
      "unableToRemove": "Unable to remove journal. Please try again."
    },
    "operations": {
      "unableToCreate": "Unable to create the operation. Please try again.",
      "unableToUpdate": "Unable to update the operation. Please try again.",
      "unableToDelete": "Unable to delete the operation. Please try again."
    },
    "profile": {
      "unableToUpdate": "Unable to update profile. Please try again.",
      "emailInUse": "This email is already in use. Please use a different email.",
      "nameRequired": "Name is required",
      "checkInfo": "Please check your information and try again.",
      "failedToDeleteAccount": "Failed to delete account. Please try again later."
    },
    "subscription": {
      "unableToLoadPlans": "Unable to load plans. Please try again.",
      "unableToCheckout": "Unable to proceed to checkout. Please try again.",
      "currencyLocked": "This plan isn't available in your existing billing currency. Please contact support to switch.",
      "unableToStartSetup": "Unable to start payment setup",
      "failedToRemovePaymentMethod": "Failed to remove payment method",
      "failedToUpdateAddress": "Failed to update address",
      "failedToCancelSubscription": "Failed to cancel subscription",
      "failedToResumeSubscription": "Failed to resume subscription"
    }
  },
  "success": {
    "boardCreated": "Board created successfully",
    "boardUpdated": "Board updated successfully",
    "boardDeleted": "Board deleted successfully",
    "boardRenamed": "Board renamed successfully",
    "connectionAdded": "Connection added successfully",
    "connectionRemoved": "Connection removed successfully",
    "channelConnected": "Channel connected successfully!"
  },
  "landing": {
    "heroBadge": "Plug the leaks. Keep the profit.",
    "heroTitle": "Your Shopify says profitable. Your bank account isn't so sure.",
    "heroSubtitle": "Dashbal pulls every real cost — the refunds, the platform fees, the COGS, the SaaS bills you forgot you signed up for — and subtracts them from your sales. What's left is the only number that lands in your bank account.",
    "copyright": "© 2026 Dashbal. All rights reserved.",
    "cta": {
      "startFree": "Start free",
      "howItWorks": "Show me how it works",
      "noCard": "See your real number in 2 minutes · Free · No card",
      "bookDemo": "Book a demo"
    },
    "nav": {
      "menu": "Open menu",
      "product": "Product",
      "solutions": "Solutions",
      "resources": "Resources",
      "pricing": "Pricing",
      "solutionsTestDesc": "Per-product break-even and kill/scale signals when you're testing winners.",
      "solutionsScaleDesc": "Blended ROAS, true CAC and 30-day cash forecast for stores that are already growing.",
      "solutionsScaleDescNoForecast": "Blended ROAS, true CAC and cash flow tracking for stores that are already growing.",
      "solutionsBrandDesc": "Custom metrics, multi-currency boards and team sharing for established brands.",
      "resourcesHowTitle": "How it works",
      "resourcesHowDesc": "From signup to your first profit number in under ten minutes.",
      "resourcesIntegrationsTitle": "Integrations",
      "resourcesIntegrationsDesc": "Stores and ad platforms that work with Dashbal out of the box.",
      "resourcesFaqTitle": "FAQ",
      "resourcesFaqDesc": "Quick answers to the questions we hear most often.",
      "resourcesDemoTitle": "Book a demo",
      "resourcesDemoDesc": "Walk through Dashbal with our team on a 30-minute call."
    },
    "pain": {
      "eyebrow": "Sound familiar?",
      "1": "Shopify says you cleared $40k this month. Your checking account says otherwise.",
      "2": "Meta swears your ROAS is 4. After refunds, fees and COGS, it's barely 1.4.",
      "3": "The spreadsheet was fine — until you turned on TikTok. Now the formulas don't add up.",
      "4": "By the time you close out the month, the bad week has already turned into a bad month."
    },
    "how": {
      "eyebrow": "Setup",
      "title": "Ten minutes from signup to your first honest number.",
      "subtitle": "No CSV exports. No integration call. No analyst on retainer.",
      "step1Title": "Plug in what you already use",
      "step1Desc": "One click for Shopify and WooCommerce. Sign in once for Meta, TikTok and Google. Your last 60–180 days appear before you've finished your coffee.",
      "step1Detail": "Every new sale, refund and ad-spend change lands in seconds — not overnight.",
      "step2Title": "Drop in the costs nobody else tracks",
      "step2Desc": "COGS, VAT, payment processing, that warehouse retainer, the SaaS subscriptions you forgot about. Snap a receipt — the AI reads the line items and files them. One-off or recurring, attached to whatever they belong to.",
      "step2Detail": "Multi-currency. Tag a channel, a product, or your whole P&L.",
      "step3Title": "See what actually landed in the bank",
      "step3Desc": "Real net profit by channel, product and ad — not the version Meta wants you to see. Daily updates, 30-day forecasts, plain-English explanations of what changed.",
      "step3DescNoForecast": "Real net profit by channel, product and ad — not the version Meta wants you to see. Daily updates, cash flow tracking, plain-English explanations of what changed.",
      "step3Detail": "Build the board your accountant would build, or start from one that already thinks like one."
    },
    "feature": {
      "eyebrow": "What's inside",
      "title": "Six tools you've been almost building yourself in spreadsheets.",
      "titleFive": "Five tools you've been almost building yourself in spreadsheets.",
      "subtitle": "One tab. Stop alt-tabbing between Shopify, Meta, TikTok and a sheet that hasn't been updated since Tuesday.",
      "channelsTitle": "Every channel, before your coffee's cold",
      "channelsDesc": "Shopify, Meta, TikTok, WooCommerce — connected once, reconciled forever. Orders, ad spend, refunds and fees land where they belong, the moment they happen.",
      "journalsTitle": "The costs no platform shows you",
      "journalsDesc": "COGS, VAT, payment fees, your $400/mo SaaS bill, the warehouse retainer. Snap a receipt — the AI lifts out the line items. Recurring or one-off, attached to what it belongs to.",
      "formulasTitle": "Your accountant's metrics, built once",
      "formulasDesc": "Build any metric your accountant asks for. Combine sales, ad spend, costs and orders in a few clicks. Save it once, reuse it on every board.",
      "forecastTitle": "30 days ahead, while there's still time",
      "forecastDesc": "Per-source revenue projections with confidence intervals. Spot the cash crunch while there's still time to do something about it.",
      "aiTitle": "An AI that reads your numbers",
      "aiDesc": "Ask anything in plain English or French. It reads the board, finds the spike, builds the chart, explains the why — in your language, not in jargon.",
      "aiQuestion": "Why is my Meta ROAS down this week?",
      "aiAnswer": "Spend grew 28% on two ad sets that under-performed. Want to pause them?",
      "sharingTitle": "Share with your real team",
      "sharingDesc": "Co-founder, accountant, assistant — invite them in one click. Read-only or edit. Multi-currency if your accountant lives somewhere else.",
      "visuals": {
        "journalLabel1": "COGS",
        "journalLabel2": "VAT",
        "journalLabel3": "SaaS fees",
        "journalValue1": "−$1,840",
        "journalValue2": "−$412",
        "journalValue3": "−$119",
        "formulaSales": "Sales",
        "formulaCosts": "Costs",
        "formulaOrders": "Orders",
        "formulaMargin": "Margin / order"
      }
    },
    "persona": {
      "eyebrow": "Built for your stage",
      "title": "Same product. Three stages. Pick yours.",
      "subtitle": "Whether you're hunting your next winner or running an eight-figure brand, you see the metrics that matter at your stage — and not the ones that don't.",
      "test": {
        "tab": "Testing winners",
        "title": "Kill it on day three. Scale it on day five.",
        "desc": "Real margin per SKU. Real CPA per ad set. The break-even line that tells you when to double — or when to walk away with a clean exit.",
        "p1": "Net margin per SKU — after refunds, fees and shipping",
        "p2": "Break-even ROAS, daily, per product",
        "p3": "Kill-or-scale signals at the ad-set level",
        "kpi1Label": "Net per order",
        "kpi1Value": "$3.84",
        "kpi2Label": "Break-even ROAS",
        "kpi2Value": "1.42×",
        "kpi3Label": "Worst SKU",
        "kpi3Value": "−$0.62",
        "chartLabel": "Margin per test (last 14 days)",
        "chartValue": "+$612.40",
        "chartTag": "3 winners"
      },
      "scale": {
        "tab": "Scaling winners",
        "title": "Scale on your numbers, not Meta's.",
        "desc": "Blended ROAS across every paid channel. True CAC after platform fees. A 30-day cash forecast so you stop scaling into red months.",
        "descNoForecast": "Blended ROAS across every paid channel. True CAC after platform fees. Real-time cash flow monitoring so you stop scaling into red months.",
        "p1": "Blended ROAS across Meta, TikTok and Google",
        "p2": "True CAC — platform fees and refunds included",
        "p3": "30-day cash forecast, by channel",
        "p3NoForecast": "Real-time cash flow monitoring, by channel",
        "kpi1Label": "Blended ROAS",
        "kpi1Value": "3.18×",
        "kpi2Label": "True CAC",
        "kpi2Value": "$24.10",
        "kpi3Label": "30-day forecast",
        "kpi3LabelNoForecast": "Cash buffer",
        "kpi3Value": "$8,420",
        "chartLabel": "Net profit (last 30 days)",
        "chartValue": "$48,120",
        "chartTag": "+22% vs prev"
      },
      "brand": {
        "tab": "Running the brand",
        "title": "A real P&L. Not a tracker.",
        "desc": "Custom metrics that match how your accountant actually thinks. Multi-currency for international teams. Read-only links for finance partners. The closest thing to a CFO that doesn't bill hourly.",
        "p1": "Custom metrics — contribution margin, COGS %, anything",
        "p2": "Multi-currency with rates you control",
        "p3": "Role-based sharing for accountants and team",
        "kpi1Label": "Gross margin",
        "kpi1Value": "31.4%",
        "kpi2Label": "Net profit MTD",
        "kpi2Value": "$182k",
        "kpi3Label": "Months runway",
        "kpi3Value": "12",
        "chartLabel": "Contribution margin (90 days)",
        "chartValue": "$214,580",
        "chartTag": "On plan"
      }
    },
    "integrations": {
      "eyebrow": "Integrations",
      "title": "The platforms you're already paying for.",
      "desc": "Secure, official connections to your stores and ad accounts. Nothing runs on your storefront, your customers never see Dashbal, your Lighthouse score doesn't notice.",
      "note": "Missing one? Tell us — most of these were built because a customer asked.",
      "soon": "Soon"
    },
    "pricing": {
      "eyebrow": "Pricing",
      "title": "Whatever you're running, a plan fits it.",
      "subtitle": "Testing one store? Start free. Scaling across channels? Step up to Starter. Running a multi-channel brand? Pro. The plan grows when you do.",
      "footnote": "Change plans or cancel anytime, right in the app. No retention games — your data's always yours.",
      "publicCta": "Get started"
    },
    "faq": {
      "eyebrow": "Questions",
      "title": "The questions every founder asks before signing up.",
      "subtitle": "Not sure which plan? Start free, see your real numbers, and move up when the business outgrows it.",
      "q1": "Do I need to be on Shopify?",
      "a1": "No. Shopify and WooCommerce both work out of the box. If you're running ads on Meta, TikTok or Google, connect those too — that's where most of the missing-money story lives.",
      "q2": "Will Dashbal slow my store down?",
      "a2": "Not even slightly. We sync through the official connection each platform provides. Nothing runs on your storefront, your customers don't load anything extra, your Lighthouse score won't notice.",
      "q3": "Where's my data and is it safe?",
      "a3": "Encrypted in transit and at rest, hosted on hardened EU and US infrastructure. We don't sell it, we don't share it. Export or delete the whole account from your settings — no support ticket required.",
      "q4": "Can I cancel?",
      "a4": "From inside the app. No phone call, no exit survey, no 'are you sure?' three times. Free plan stays free. Your data stays accessible.",
      "q5": "How is this different from Triple Whale or Lifetimely?",
      "a5": "Triple Whale leans on attribution; Lifetimely on lifetime value. Dashbal's whole focus is your real net profit after every cost — with native Shopify and WooCommerce, correct VAT handling, AI receipt-to-expense journals, a 30-day cash forecast, and an AI that builds your charts. In English and French, with a genuinely free plan — not just a trial.",
      "a5NoForecast": "Triple Whale leans on attribution; Lifetimely on lifetime value. Dashbal's whole focus is your real net profit after every cost — with native Shopify and WooCommerce, correct VAT handling, AI receipt-to-expense journals, real-time cash flow monitoring, and an AI that builds your charts. In English and French, with a genuinely free plan — not just a trial.",
      "q6": "Can I import my historical data?",
      "a6": "Yes. On connect, we pull whatever each platform allows — usually 60 to 180 days. Money journals accept past entries and recurring rules from day one.",
      "q7": "Who can I share with?",
      "a7": "Co-founders, accountants, assistants, finance partners. Read-only or edit, board by board. Shared users don't need a paid plan to see what you shared with them."
    },
    "finalCta": {
      "title": "See the number that actually lands in the bank.",
      "subtitle": "Connect a store and one ad account — Dashbal shows your real net profit, after every cost, in about two minutes. Free, no card."
    },
    "hero": {
      "totalRevenue": "Total Revenue",
      "netProfit": "Net Profit",
      "adSpend": "Ad Spend",
      "vsLastWeek": "vs prev period",
      "revenueGrowth": "Revenue Growth",
      "thisMonth": "This month",
      "aiInsight": "MARGIN ALERT",
      "insightTextPart1": "Your ad spend on",
      "insightTextPart2": "and",
      "insightTextPart3": "went up this week — margins didn't follow. Two ad sets are dragging the average.",
      "applyRecommendation": "Show me",
      "activeChannels": "Connected channels",
      "connected": "Connected",
      "roasAlert": "ROAS DROP",
      "checkMetaAds": "Pause 2 ad sets"
    }
  },
  "demo": {
    "heroBadge": "30 minutes. No slides.",
    "heroTitle": "Bring your numbers. We'll show you what they actually say.",
    "heroSubtitle": "We open Dashbal with your channels in mind, answer the awkward questions, and tell you straight whether it'll move the needle for your store. Or whether it won't — yet.",
    "form": {
      "title": "Tell us a bit about your store",
      "subtitle": "We use this to make the call useful. Nothing gets shared, nothing goes on a list.",
      "name": "Your name",
      "namePlaceholder": "Jane Doe",
      "email": "Work email",
      "emailPlaceholder": "you@store.com",
      "company": "Store or brand name",
      "companyPlaceholder": "Acme Apparel",
      "role": "Your role",
      "rolePlaceholder": "Founder, CMO, finance lead…",
      "teamSize": "Team size",
      "teamSizePlaceholder": "How many of you?",
      "monthlyRevenue": "Monthly revenue",
      "monthlyRevenuePlaceholder": "Pick a range",
      "revenue": {
        "under_10k": "Under $10k",
        "10k_50k": "$10k – $50k",
        "50k_250k": "$50k – $250k",
        "250k_1m": "$250k – $1M",
        "over_1m": "Over $1M"
      },
      "channels": "Where do you sell or advertise?",
      "slot": "Pick a time that works for you",
      "slotNote": "Times are shown in your local timezone. We'll confirm by email.",
      "message": "Anything specific you want to see?",
      "messagePlaceholder": "A product whose margin you can't trust? A dashboard you'd kill for? An invoice that didn't match what Meta said?",
      "submit": "Request demo",
      "submitting": "Sending…",
      "errorGeneric": "Something went wrong on our end. Please try again in a moment.",
      "privacy": "We don't share your details and we won't drop you on a marketing list."
    },
    "benefits": {
      "title": "What you'll get from the call",
      "b1": "Thirty minutes focused on the features that matter at your stage.",
      "b2": "Live answers from someone who built the product, not a sales rep with a script.",
      "b3": "An honest second opinion on the numbers you can already see.",
      "b4": "A clear next step — including 'not yet' if that's the right answer."
    },
    "languages": {
      "title": "EN or FR — your call",
      "body": "Pick whichever language you'd run a P&L review in. Same team, same product, same level of detail."
    },
    "startNow": {
      "title": "Want to poke around first?",
      "body": "Start free, connect a channel, and see your real numbers in minutes. Step up to Starter or Pro as you add channels and history — or book a call if you want a hand."
    },
    "success": {
      "title": "We've got it.",
      "body": "We'll come back within one business day with a confirmed slot. If you don't see anything, check your spam — and if it's still missing, just reply to any of our emails.",
      "bookAnother": "Send another request"
    }
  },
  "oauth": {
    "errorTitle": "Connection Issue",
    "successTitle": "OAuth Success",
    "authorizationFailed": "Authorization Failed",
    "authorizationSuccessful": "Authorization Successful",
    "windowWillClose": "This window will close automatically...",
    "missingParameters": "We couldn't complete the connection",
    "invalidState": "The connection session has expired",
    "duplicateConnection": "You already have a connection for this channel. Please disconnect the existing one first.",
    "pluginNotFound": "Channel plugin not found",
    "serverError": "We had trouble connecting to the service",
    "safeToClose": "Safe to close now",
    "secureGateway": "Dashbal Secure Gateway"
  },
  "datePicker": {
    "selectDateRange": "Select date range",
    "startDate": "Start Date",
    "endDate": "End Date",
    "quickRanges": "Quick ranges",
    "yesterday": "Yesterday",
    "last7Days": "Last 7 days",
    "last30Days": "Last 30 days",
    "last60Days": "Last 60 days",
    "last365Days": "Last 365 days",
    "apply": "Apply",
    "cancel": "Cancel"
  },
  "currency": {
    "boardCurrency": "Board Currency",
    "defaultCurrency": "Default Currency",
    "convertedCurrencies": "Converted Currencies",
    "currencyConversion": "Currency Conversion",
    "conversionRate": "Conversion Rate",
    "to": "to",
    "changeCurrency": "Change Currency",
    "mixedCurrenciesWarning": "Multiple currencies detected in board",
    "disclaimer": "Currency conversion rates are user-defined and for reference only. Dashbal is not responsible for the accuracy of these conversions. Please verify rates with your financial institution.",
    "noCurrency": "No currency set",
    "currencyUpdated": "Currency updated successfully",
    "selectCurrency": "Select Currency",
    "automaticRate": "Automatic rate from market data",
    "resetToAutomatic": "Reset to automatic rate",
    "rateReset": "Rate reset to automatic",
    "rateResetFailed": "Failed to reset rate",
    "ratesUpdated": "Currency rates updated",
    "newCurrenciesDetected": "New currencies detected: {{currencies}}",
    "updateSuccess": "Currency settings updated successfully",
    "updateFailed": "Failed to update currency settings",
    "previewFailed": "Failed to load currency preview",
    "usd": "USD - US Dollar",
    "eur": "EUR - Euro",
    "gbp": "GBP - British Pound",
    "jpy": "JPY - Japanese Yen",
    "cad": "CAD - Canadian Dollar",
    "aud": "AUD - Australian Dollar",
    "chf": "CHF - Swiss Franc",
    "cny": "CNY - Chinese Yuan",
    "inr": "INR - Indian Rupee",
    "brl": "BRL - Brazilian Real",
    "tnd": "TND - Tunisian Dinar"
  },
  "itemSelection": {
    "title": "Data Selection",
    "subtitle": "Select items from {{channelName}}",
    "manageSelections": "Manage your data selections across all channels",
    "selectItems": "Select Items",
    "selectItemsDescription": "Choose the data sources you want to track on this board",
    "selectEntitiesDescription": "Manage your data sources and journals for this board",
    "preview": "Selection Preview",
    "previewDescription": "Review your selected items before validating",
    "noSelection": "No items selected",
    "noSelectionHint": "Select items from the list on the left to preview them here",
    "selectedCount": "{{count}} items selected",
    "readyToValidate": "{{count}} items ready to be added",
    "selected": "selected",
    "selectItemsInstructions": "Select items to include in board",
    "selectEntitiesInstructions": "Select items to include in board",
    "noSelectionWarning": "No items selected - validating will remove this channel",
    "validate": "Confirm",
    "noSelectionTitle": "No Items Selected",
    "noSelectionMessage": "You haven't selected any items. If you validate now, this channel will be removed from the board. Do you want to continue?",
    "removeChannel": "Remove Channel",
    "openModal": "Open data selection",
    "clickToOpen": "Click the + button to manage your data selections",
    "selectAccount": "Select an account to view"
  },
  "profile": {
    "appearance": "Appearance",
    "themeLight": "Light",
    "themeDark": "Dark",
    "themeSystem": "Auto",
    "general": "General",
    "channels": "Channels",
    "notifications": "Notifications",
    "plan": "Plan",
    "billing": {
      "label": "Billing",
      "confirmRemovePaymentMethod": "Are you sure you want to remove this payment method?",
      "cancelSubscriptionMessage": "Your subscription will remain active until the end of your current billing period. You can resume anytime before then.",
      "confirmCancelAction": "Yes, Cancel Plan",
      "keepPlanAction": "Keep Plan",
      "cancellationNotice": "Your subscription will end on {{date}}. You can still use all features until then.",
      "endsOn": "Ends on {{date}}",
      "renewsOn": "Renews on {{date}}",
      "paymentIssue": "Payment Issue",
      "paymentIssueDesc": "Your last payment failed. Please update your payment method.",
      "updatePaymentMethod": "Update payment method",
      "switchingTo": "Switching to {{plan}} on",
      "cancelSchedule": "Cancel schedule"
    },
    "activity": "Activity history",
    "privacy": {
      "label": "Privacy",
      "deleteAccountTitle": "Danger Zone",
      "deleteAccountDesc": "Permanently delete your account and all associated data, including Facebook platform data. This action cannot be undone.",
      "deleteAccountBtn": "Delete Account & Data",
      "shopifyDeleteLockedTitle": "Uninstall from Shopify first",
      "shopifyDeleteLockedDesc": "Your subscription is managed by Shopify. To delete your account, first uninstall the Dashbal app from your Shopify admin — this cancels the subscription and starts the data-removal grace period. Once that's done, you'll be able to delete your account here.",
      "confirmDeleteAccountTitle": "Delete Account?",
      "confirmDeleteAccountMsg": "Are you sure you want to delete your account? All your data, including connected Facebook data, will be permanently removed from our servers.",
      "accountDeleted": "Your account has been deleted successfully."
    },
    "manageAccount": "Manage your account settings and preferences",
    "filter": "Filter",
    "allActivity": "All Activity",
    "event": "activity",
    "events": "activities",
    "noActivity": "No activity yet",
    "activityDescription": "Your account activity will appear here",
    "loadMoreActivity": "Load more activity",
    "loadingActivity": "Loading...",
    "categories": {
      "label": "Categories",
      "security": "Security",
      "payment": "Billing",
      "channel": "Integrations",
      "board": "Boards",
      "user": "Account"
    },
    "profilePhoto": "Profile Photo",
    "photoDescription": "Upload a profile picture to personalize your account. We recommend using a square image.",
    "uploadPhoto": "Upload Photo",
    "removePhoto": "Remove Photo",
    "editPhoto": "Edit Photo",
    "personalInfo": "Personal Information",
    "changePassword": "Change Password",
    "currentPassword": "Current Password",
    "newPassword": "New Password",
    "updatePassword": "Update Password",
    "preferences": "Preferences",
    "defaultCurrency": "Default Currency",
    "timezone": "Timezone",
    "security": "Security",
    "passwordLastChanged": "Password last changed",
    "user": "User",
    "myChannels": "My Channels",
    "manageChannelSettings": "View and manage all your connected sales and marketing channels",
    "connectChannelsToStart": "Connect your first channel to start importing and tracking your financial data",
    "emailNotifications": "Email Notifications",
    "emailNotificationsLabel": "Receive Email Updates",
    "emailNotificationsDesc": "Get email notifications about important account activity and updates",
    "channelAlerts": "Channel Connection Alerts",
    "channelAlertsDesc": "Receive alerts when there are connection issues or sync problems with your channels",
    "weeklyReports": "Weekly Summary Reports",
    "weeklyReportsDesc": "Get a weekly email summary of your sales, revenue, and key metrics",
    "monthlyReports": "Monthly Summary Reports",
    "monthlyReportsDesc": "Receive a comprehensive monthly report with insights and trends",
    "systemNotifications": "System & Account Notifications",
    "securityAlerts": "Security & Login Alerts",
    "securityAlertsDesc": "Get notified about important security alerts like new logins and password changes",
    "marketingEmails": "Product Updates & News",
    "marketingEmailsDesc": "Stay informed about new features, product updates, and special offers",
    "currentPlan": "Current Plan",
    "planRenews": "Renews on",
    "selectPlan": "Select Plan",
    "upgrade": "Upgrade Plan",
    "paymentMethod": "Payment Method",
    "addPaymentMethod": "Add Payment Method",
    "billingHistory": "Billing History",
    "download": "Download Invoice",
    "cancelSubscription": "Cancel Subscription",
    "cancelSubscriptionDesc": "Once you cancel, you'll lose access to all premium features at the end of your current billing period. Your data will be preserved for 30 days.",
    "addressLine1": "Address Line 1",
    "city": "City",
    "state": "State",
    "zipCode": "ZIP / Postal Code",
    "countryPlaceholder": "Country (e.g. US)",
    "paymentMethods": "Payment Methods",
    "noPaymentMethods": "No payment methods saved.",
    "loadingBillingHistory": "Loading billing history...",
    "noBillingHistory": "No billing history available",
    "unsavedChanges": "Unsaved changes",
    "cancelPlan": "Cancel Plan",
    "keepSubscription": "Keep my subscription",
    "cancellationScheduled": "Cancellation scheduled.",
    "billingAddress": "Billing Address",
    "noAddressSet": "No address set",
    "confirmPassword": "Confirm Password",
    "freePlan": "Free Plan",
    "freeTrial": "Free trial",
    "noSubscription": "No active subscription",
    "noSubscriptions": "No subscriptions",
    "trialExpiresToday": "Trial expires today",
    "cancelTrial": "Cancel trial",
    "trialDaysLeft": "{{count}} day left in trial",
    "trialDaysLeft_plural": "{{count}} days left in trial",
    "viewPlans": "View plans",
    "canceling": "CANCELING",
    "downloadInvoice": "Download Invoice",
    "analytics": "Analytics",
    "analyticsDesc": "Enable analytics tracking",
    "saving": "Saving...",
    "discardChanges": "Discard Changes",
    "saveChanges": "Save Changes",
    "public": "Public Profile"
  },
  "transactionCategories": {
    "product_sale": "Product Sales",
    "product_return": "Product Returns",
    "partial_return": "Partial Returns",
    "discount": "Discounts",
    "shipping": "Shipping",
    "shipping_refund": "Shipping Refunds",
    "tax": "Taxes",
    "tax_refund": "Tax Refunds",
    "refund_adjustment": "Refund Adjustments",
    "transaction_fee": "Processing Fees",
    "net_return": "Returns",
    "other": "Other"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "creating": "Creating...",
    "saving": "Saving...",
    "delete": "Delete",
    "remove": "Remove",
    "duplicate": "Duplicate",
    "copy": "Copy",
    "selected": "selected",
    "operations": "operations",
    "noItemsFound": "No items found",
    "success": "Success",
    "revenue": "Revenue",
    "expense": "Expense",
    "expenses": "Expenses",
    "edit": "Edit",
    "items": "items",
    "selectAll": "Select All",
    "unnamed": "Unnamed",
    "created": "Created",
    "date": "Date",
    "updating": "Updating...",
    "noResults": "No results found",
    "alreadySelected": "Already Selected",
    "search": "Search",
    "productsCount": "{{count}} Products",
    "noProductsFound": "No products found",
    "margin": "Margin",
    "forecast": "Forecast",
    "gotIt": "Got it",
    "more": "More",
    "exporting": "Exporting...",
    "viewFiles": "Documents",
    "addFiles": "Documents",
    "goBack": "Go Back",
    "decline": "Decline",
    "accepting": "Accepting...",
    "accept": "Accept",
    "enable": "Enable",
    "disable": "Disable",
    "loading": "Loading...",
    "added": "Added",
    "actual": "Actual",
    "download": "Download",
    "lower": "Lower",
    "upper": "Upper",
    "channels": {
      "syncing": "Syncing..."
    }
  },
  "itemTypes": {
    "adAccount": "Ad Account",
    "campaign": "Campaign",
    "adSet": "Ad Set",
    "ad": "Ad"
  },
  "modals": {
    "addJournal": {
      "title": "Add New Journal",
      "journalName": "Journal Name",
      "namePlaceholder": "e.g., Q1 Budget, Freelance Income",
      "importDataOptional": "Import Data (Optional)",
      "dropZone": {
        "title": "Drop a file here",
        "subtitle": "or click to browse",
        "formats": "CSV, Excel files supported"
      },
      "createAction": "Create Journal",
      "error": "Failed to create journal. Please try again."
    },
    "addFinancialOperation": {
      "title": "Add Operation",
      "amount": "Amount",
      "currency": "Currency",
      "operationStructure": "Operation Structure",
      "oneTime": "One-time Payment",
      "periodic": "Periodic Payment",
      "date": "Date",
      "startDate": "Start Date",
      "frequency": "Frequency",
      "frequencies": {
        "daily": "Daily",
        "weekly": "Weekly",
        "monthly": "Monthly",
        "yearly": "Yearly"
      },
      "endDateOptional": "End Date (Optional)",
      "endDate": "End Date",
      "createAction": "Add Operation",
      "error": "Failed to create operation"
    },
    "shareJournal": {
      "title": "Share \"{{name}}\"",
      "subtitle": "Share this journal with other users",
      "emailLabel": "Email Address",
      "permissionLabel": "Permission",
      "inviteButton": "Invite",
      "usersWithAccess": "Users with access",
      "owner": "Owner",
      "remove": "Remove"
    },
    "exportOperations": {
      "title": "Export Operations",
      "subtitle": "Choose the best format for your needs",
      "formats": {
        "csvExcel": "CSV for Excel",
        "csvExcelDesc": "Optimized for Excel, Numbers, and other spreadsheet tools",
        "csvPlain": "Plain CSV",
        "csvPlainDesc": "Standard comma-separated values file"
      }
    },
    "operationFileExplorer": {
      "title": "Operation Files",
      "empty": "No files attached",
      "emptyDesc": "Drag and drop files here or use the button above to attach documents to this operation.",
      "tip": "Tip: Drag and drop files anywhere to upload instantly",
      "searchPlaceholder": "Search files...",
      "addFile": "Add File",
      "uploading": "Uploading...",
      "alerts": {
        "loadError": "Failed to load files",
        "uploadSuccess": "File uploaded successfully",
        "uploadError": "Failed to upload file",
        "deleteSuccess": "File deleted",
        "deleteError": "Failed to delete file",
        "downloadError": "Failed to download file"
      }
    }
  },
  "sharing": {
    "share": "Share",
    "readOnly": "Read Only",
    "permissions": {
      "read": "Read Only",
      "readwrite": "Read & Write"
    },
    "invalidLink": "Invalid Share Link",
    "accepted": "Share Accepted!",
    "acceptedDesc": "The journal has been added to your shared journals.",
    "redirecting": "Redirecting...",
    "ownJournal": "This is Your Journal",
    "ownJournalDesc": "You can",
    "goToJournals": "Go to Journals",
    "alreadyAccepted": "Already Accepted",
    "alreadyAcceptedDesc": "You already have access to this journal.",
    "invitationTitle": "Journal Shared With You",
    "sharedWith": "has shared a journal with you",
    "canEdit": "You can view and add operations",
    "canView": "You can view operations",
    "readWriteAccess": "Read & Write Access",
    "readOnlyAccess": "Read Only Access",
    "removeAccess": "Remove Access",
    "removeShareTitle": "Remove Access?",
    "removeShareMessage": "Are you sure you want to remove access for {{email}}? This action cannot be undone.",
    "updateSuccess": "Journal shares updated successfully",
    "updateError": "Failed to update journal shares",
    "readWrite": "Read & Write",
    "addAnother": "Add another person"
  },
  "boardJournals": {
    "inBoardModal": {
      "openInFullView": "Open in full view",
      "creating": "Creating journal..."
    },
    "tabs": {
      "myJournals": "My Journals",
      "sharedWithMe": "Shared with Me"
    },
    "list": {
      "headers": {
        "status": "Status",
        "name": "Journal",
        "actions": "Actions"
      },
      "emptyState": "No journals found. Add one to get started.",
      "confirmDelete": "Are you sure you want to delete this journal?",
      "deleteJournal": "Delete Journal",
      "journalDeleted": "Journal deleted successfully",
      "deleteJournals": "Delete Journals",
      "confirmDeleteBulk": "Are you sure you want to delete these journals?"
    },
    "journal": "Journal",
    "types": {
      "automated": "Automated"
    },
    "details": {
      "headers": {
        "operation": "Operation Name",
        "amount": "Amount",
        "date": "Date"
      },
      "emptyState": "No operations found.",
      "loading": "Loading operations...",
      "emptyStateText": "Add an operation to this journal to get started.",
      "viewOnlyInfo": "View operations included in board",
      "untitledOperation": "Untitled Operation",
      "defaultOperationName": "Operation {{number}}",
      "amountPlaceholder": "0.00",
      "recurring": "Recurring",
      "openEnded": "Open-ended",
      "deleteConfirm": "Are you sure you want to delete this operation?",
      "frequencies": {
        "daily": "Daily",
        "weekly": "Weekly",
        "monthly": "Monthly",
        "yearly": "Yearly"
      },
      "deleteOperation": "Delete Operation",
      "operationDeleted": "Operation deleted successfully",
      "operationCreated": "Operation created successfully",
      "chooseFileOrDragAndDrop": "Choose a file or drag and drop",
      "aiFileAnalysis": "AI Document Import",
      "aiAnalysisPromo": "for instant AI analysis",
      "dragActive": "Drop to analyze",
      "dragActiveSubtitle": "AI will process your file instantly",
      "aiProcessing": {
        "analyzing": "Analyzing document structure",
        "extracting": "Extracting financial data",
        "classifying": "Classifying records",
        "finalizing": "Finalizing journal entries"
      },
      "cancelProcessing": "Cancel analysis",
      "deleteOperations": "Delete Operations",
      "confirmDeleteBulk": "Are you sure you want to delete these operations?"
    },
    "addJournal": "Add New Journal",
    "createJournal": "Create a journal",
    "manageJournals": "Manage Journals",
    "emptyTitle": "No journals yet",
    "emptyDescription": "Journals hold financial operations like one-time or recurring records. Add them to your board analysis."
  },
  "journals": {
    "myJournals": "My Journals",
    "sharedWithMe": "Shared with Me",
    "journal": "Journal",
    "emptyTitle": "No journals yet",
    "emptyDescription": "Journals are global journals of financial operations. You can link them to any board.",
    "noSharedJournals": "No shared journals",
    "noSharedJournalsDescription": "Journals shared with you will appear here.",
    "deleteJournal": "Delete Journal",
    "confirmDelete": "Are you sure you want to delete this journal permanently? This will remove it from all boards and delete all its operations.",
    "deleteJournals": "Delete Journals",
    "confirmDeleteBulk": "Are you sure you want to delete these journals?"
  },
  "plans": {
    "unlockTitle": "Unlock Your Plan",
    "paymentIssue": "There is an issue with your payment method. Please update it in your profile to keep your subscription active.",
    "loading": "Loading plans...",
    "noPlansAvailable": "No plan available in your region.",
    "billingViaShopify": "Dashbal billing is handled through the Shopify App Store.",
    "getOnShopify": "Get Dashbal on Shopify",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "perMonth": "month",
    "perYear": "year",
    "billedAnnually": "billed annually",
    "billedMonthly": "billed monthly",
    "freePrice": "Free",
    "currentPlan": "Current Plan",
    "getStarted": "Get Started",
    "upgradeTo": "Upgrade to {{planName}}",
    "pricesFor": "Prices for",
    "defaultDescription": "Everything you need to get started.",
    "downgradeToFree": "Switch to Free",
    "confirmDowngrade": "Switch to Free Plan?",
    "getPlan": "Get {{planName}}",
    "downgradeMessage": "Your current subscription will be canceled at the end of the billing period, and you will revert to the free plan.",
    "changePlan": "Change Your Plan",
    "loadPreviewFailed": "Unable to load plan change details",
    "changePlanFailed": "Failed to change plan",
    "current": "Current",
    "new": "New",
    "credit": "Credit",
    "paymentSummary": "Payment Summary",
    "dueNow": "Due Now",
    "nextPayment": "Next Payment {{frequency}}",
    "processing": "Processing...",
    "confirmChange": "Confirm Change",
    "downgradeSuccess": "Plan downgraded successfully (pending period end)",
    "downgradeFailed": "Failed to downgrade plan",
    "updateSuccess": "Plan updated successfully"
  },
  "timezones": {
    "utc": "UTC",
    "usEastern": "US/Eastern",
    "usCentral": "US/Central",
    "usMountain": "US/Mountain",
    "usPacific": "US/Pacific",
    "europeLondon": "Europe/London",
    "europeParis": "Europe/Paris",
    "europeBerlin": "Europe/Berlin",
    "asiaDubai": "Asia/Dubai",
    "asiaKolkata": "Asia/Kolkata",
    "asiaSingapore": "Asia/Singapore",
    "asiaTokyo": "Asia/Tokyo",
    "australiaSydney": "Australia/Sydney"
  },
  "maintenance": {
    "title": "Developer Access Required",
    "description": "This environment is restricted to developers only. Please enter your access code to continue.",
    "accessCode": "Access Code",
    "enterCode": "Enter access code",
    "verifying": "Verifying...",
    "accessApp": "Access Application",
    "contactAdmin": "If you don't have an access code, please contact your administrator.",
    "footer": "© {{year}} Dashbal. Developer Environment.",
    "pleaseEnterCode": "Please enter an access code",
    "invalidCode": "Invalid access code",
    "loading": "Loading..."
  },
  "help": {
    "center": "Help Center",
    "howCanWeHelp": "How can we help you?",
    "sendMessageDesc": "Send us a message and we'll get back to you shortly.",
    "name": "Name",
    "namePlaceholder": "Your name",
    "email": "Email",
    "emailPlaceholder": "you@example.com",
    "subject": "Subject",
    "generalInquiry": "General Inquiry",
    "technicalSupport": "Technical Support",
    "billingQuestion": "Billing Question",
    "featureRequest": "Feature Request",
    "other": "Other",
    "message": "Message",
    "messagePlaceholder": "Describe your issue or question...",
    "sendMessage": "Send Message",
    "orEmailUs": "Or email us directly at"
  },
  "checkout": {
    "processing": "Processing Payment...",
    "waitConfirm": "Please wait while we confirm your subscription.",
    "takingLonger": "Taking longer than expected",
    "couldNotConfirm": "We couldn't confirm your subscription yet. It might take a few moments.",
    "errorTitle": "Something went wrong",
    "sessionMismatch": "This checkout session belongs to a different account. Please make sure you're logged in with the correct account and try again.",
    "sessionExpired": "This checkout session has expired or is invalid. Please start a new checkout from the pricing page.",
    "returnToProfile": "Return to Profile",
    "successMessage": "Subscription successfully activated!"
  },
  "documentAnalysis": {
    "title": "AI Document Import",
    "analyzing": "Analyzing document...",
    "extracting": "Extracting operations...",
    "processing": "Processing your document",
    "success": "Operations extracted successfully",
    "noOperationsFound": "No operations found in document",
    "operationsFound": "{{count}} operations found",
    "operationsSaved": "{{count}} operations saved to journal",
    "partialSave": "{{saved}} of {{total}} operations saved",
    "reviewOperations": "Review extracted operations",
    "confirmImport": "Import Operations",
    "cancelImport": "Cancel",
    "retryAnalysis": "Try Again",
    "supportedFormats": "Supported formats: Images, PDFs, CSV, Excel",
    "maxFileSize": "Maximum file size: {{size}}MB",
    "dropToAnalyze": "Drop file to analyze",
    "clickOrDrop": "Click or drop a file to analyze",
    "viewFile": "View File",
    "results": {
      "title": "Analysis Results",
      "totalOperations": "Total Operations",
      "totalRevenue": "Total Revenue",
      "totalExpense": "Total Expenses",
      "currencies": "Currencies Detected",
      "confidence": "Confidence",
      "warnings": "Warnings"
    },
    "errors": {
      "generic": "Failed to analyze document. Please try again.",
      "noFileProvided": "Please select a file to analyze.",
      "fileTooLarge": "The file is too large. Please choose a smaller file.",
      "unsupportedFileType": "This file type is not supported. Please use an image, PDF, CSV, or Excel file.",
      "fileCorrupted": "The file appears to be corrupted or damaged.",
      "fileEmpty": "The file is empty. Please choose a file with content.",
      "fileReadError": "Could not read the file. Please try again.",
      "providerNotConfigured": "We're currently unable to analyze documents. Please contact support.",
      "providerNotFound": "Document analysis service not found.",
      "providerConnectionFailed": "We're having trouble reaching our analysis service. Please try again.",
      "providerAuthFailed": "We're having trouble connecting to our analysis service. Please contact support.",
      "providerTimeout": "Analysis timed out. Please try a smaller file or try again.",
      "providerUnavailable": "The analysis service is temporarily offline. Please try again in a few moments.",
      "analysisFailed": "Failed to analyze the document. Please try again.",
      "noOperationsFound": "No financial operations could be found in this document.",
      "invalidDataFormat": "We couldn't read this document. Please check the file format.",
      "partialExtraction": "Some data could not be extracted from the document.",
      "ambiguousCurrency": "Multiple currencies detected. Please review the results.",
      "dateParsingFailed": "Some dates could not be parsed correctly.",
      "amountParsingFailed": "Some amounts could not be read correctly.",
      "rateLimitExceeded": "Too many requests. Please wait a moment and try again.",
      "quotaExceeded": "Analysis quota exceeded. Please try again later.",
      "concurrentLimit": "Too many files being processed. Please wait and try again."
    }
  },
  "legal": {
    "lastUpdated": "Last Updated",
    "tos": {
      "title": "Terms of Service",
      "sections": {
        "intro": {
          "title": "1. Acceptance of Terms",
          "content": "These Terms of Service (\"Terms\") constitute a legally binding agreement between you (\"User,\" \"you,\" or \"your\") and Dashbal (\"Dashbal,\" \"we,\" \"us,\" or \"our\"), governing your access to and use of the Dashbal platform, website, applications, and related services (collectively, the \"Service\").\n\nBy creating an account, clicking \"I Agree,\" or accessing the Service, you confirm that you have read, understood, and agree to be bound by these Terms and our Privacy Policy (incorporated herein by reference). If you do not agree, you may not use the Service.\n\nThese Terms apply to all users, including individuals, businesses, and any party accessing the Service on behalf of an entity. If you use the Service on behalf of an organization, you represent that you have authority to bind that organization to these Terms."
        },
        "eligibility": {
          "title": "2. Eligibility",
          "content": "To use the Service, you must:\n• Be at least 18 years of age\n• Have the legal capacity to enter into binding contracts under applicable law\n• Not be prohibited from using the Service under the laws of your jurisdiction\n• Use the Service solely for lawful business purposes\n\nBy creating an account, you represent and warrant that all registration information you provide is accurate, current, and complete, and that you will maintain the accuracy of such information throughout your use of the Service."
        },
        "accounts": {
          "title": "3. User Accounts",
          "content": "Account Responsibility: You are solely responsible for maintaining the confidentiality of your login credentials and for all activities occurring under your account. Notify us immediately at support@dashbal.com of any unauthorized access or suspected breach.\n\nAccount Integrity: You may not create more than one account per individual or entity without our prior written consent. You may not impersonate another person, create accounts using false identities, or transfer your account to another party.\n\nInactivity: We reserve the right to suspend accounts inactive for more than 12 consecutive months after providing 30 days' prior written notice."
        },
        "billing": {
          "title": "4. Subscriptions, Billing, and Payments",
          "content": "Subscription Plans: The Service is offered on a subscription basis. Available plans and pricing are described on our pricing page. We reserve the right to modify plan features and pricing with advance notice.\n\nBilling: Fees are billed in advance on a monthly or annual basis. Payments are processed by Stripe, Inc. By providing payment information, you authorize Dashbal and Stripe to charge applicable fees.\n\nTaxes: Prices are exclusive of taxes, levies, and duties. You are responsible for all applicable taxes, including VAT where applicable.\n\nAutomatic Renewal: Subscriptions renew automatically unless cancelled at least 48 hours before the end of the current billing period. You may cancel at any time in your account settings.\n\nRefund Policy: All fees are non-refundable except where required by applicable law or expressly stated in our refund policy. No refunds are issued for partial periods of service.\n\nPrice Changes: We will provide at least 30 days' written notice before increasing subscription prices. Continued use of the Service after a price change constitutes acceptance of the new pricing.\n\nFailed Payments: If payment fails, we may suspend access to paid features until payment is resolved.\n\nFree Trial: If offered, free trials are available to new users only, one per individual or entity."
        },
        "usage": {
          "title": "5. Acceptable Use Policy",
          "content": "You agree to use the Service only for lawful purposes and in compliance with these Terms. You must not:\n\n• Violate any applicable laws, regulations, or third-party rights\n• Attempt to gain unauthorized access to the Service, other accounts, or related systems\n• Reverse engineer, decompile, or disassemble any part of the Service\n• Introduce malicious code, viruses, or other harmful software\n• Use automated tools to scrape, crawl, or excessively load the Service beyond intended use\n• Impersonate Dashbal, its employees, or other users\n• Send unsolicited commercial communications (spam) using the Service\n• Circumvent any access controls, usage limits, or security features\n• Use the Service in violation of third-party platform terms (e.g., Shopify, Meta, TikTok API terms)\n• Resell, sublicense, or commercially exploit the Service without our prior written consent\n\nWe reserve the right to investigate suspected violations and to suspend or terminate access without prior notice upon discovery of a breach of this Policy."
        },
        "content": {
          "title": "6. Your Data and Content",
          "content": "Your Ownership: You retain full ownership of all data, content, and information you upload, connect, or submit through the Service (\"User Data\").\n\nLicense to Dashbal: You grant Dashbal a limited, non-exclusive, royalty-free, worldwide license to access, process, store, and display your User Data solely to: (a) provide and maintain the Service; (b) respond to your support requests; and (c) comply with legal obligations. This license terminates when you delete your data or close your account.\n\nAggregated Data: We may use anonymized, aggregated, de-identified data derived from your use of the Service for product improvement, benchmarking, and research, provided such data cannot reasonably identify you.\n\nData Accuracy: You are solely responsible for the accuracy, quality, and legality of your User Data and for your means of obtaining it from third-party platforms."
        },
        "ip": {
          "title": "7. Intellectual Property",
          "content": "Dashbal's Property: The Service — including all software, algorithms, user interfaces, designs, text, graphics, logos, trademarks, and trade secrets — is the exclusive intellectual property of Dashbal and its licensors, protected by copyright, trademark, patent, and other applicable laws. You are granted only a limited, non-exclusive, non-transferable, revocable license to use the Service in accordance with these Terms.\n\nRestrictions: You may not copy, modify, distribute, sell, lease, sublicense, or create derivative works based on the Service or any part thereof without our prior written consent.\n\nFeedback: Any suggestions, feedback, or ideas you provide about the Service are granted to Dashbal on an irrevocable, perpetual, royalty-free, worldwide basis, without any obligation to you."
        },
        "ai": {
          "title": "8. AI Features and Limitations",
          "content": "The Service includes artificial intelligence and machine learning features powered by third-party providers (including Google Gemini). You acknowledge and agree that:\n\n• AI-generated insights, recommendations, and analysis are provided for informational purposes only and do not constitute financial, legal, tax, accounting, or professional advice of any kind\n• AI outputs may contain errors, inaccuracies, or limitations and must not be relied upon as the sole basis for any business decision\n• You are solely responsible for independently verifying AI-generated outputs before acting upon them\n• We reserve the right to monitor AI usage to ensure compliance with these Terms and applicable third-party API terms\n• Content you submit to AI features may be processed by third-party AI providers subject to their respective privacy and usage policies\n\nDISCLAIMER: AI-GENERATED OUTPUTS ARE PROVIDED \"AS IS\" WITHOUT ANY WARRANTY OF ACCURACY, COMPLETENESS, OR FITNESS FOR A PARTICULAR PURPOSE. DASHBAL SHALL NOT BE LIABLE FOR ANY DECISIONS MADE OR ACTIONS TAKEN BASED ON AI-GENERATED OUTPUTS."
        },
        "thirdParty": {
          "title": "9. Third-Party Integrations",
          "content": "The Service allows you to connect third-party platforms including Shopify, Meta (Facebook/Instagram), TikTok, and WooCommerce. By connecting these platforms, you:\n\n• Represent that you have the right and authority to connect such accounts and grant the required permissions\n• Acknowledge that your use of these integrations is subject to the terms and policies of the respective third-party platforms\n• Agree that Dashbal is not responsible for the availability, accuracy, or content of third-party platforms or data sources\n• Understand that changes to third-party APIs or policies may affect Service functionality, and Dashbal shall not be liable for any resulting disruptions, data loss, or service degradation\n\nDashbal does not endorse and is not responsible for any third-party products, services, or websites accessed through or in connection with the Service."
        },
        "termination": {
          "title": "10. Term and Termination",
          "content": "Termination by You: You may terminate your account at any time by contacting us at support@dashbal.com or using the account deletion option in your account settings. Termination does not entitle you to a refund of any prepaid fees.\n\nTermination by Dashbal: We may suspend or terminate your access immediately, without prior notice or liability, if:\n• You breach any provision of these Terms\n• We are required to do so by law or a regulatory authority\n• Your account poses a security risk to other users or the Service\n• We discontinue the Service (with reasonable advance notice where possible)\n\nEffect of Termination: Upon termination, your right to use the Service immediately ceases. We will handle your data as described in our Privacy Policy. Provisions that by their nature survive termination shall remain in effect, including intellectual property rights, warranty disclaimers, limitation of liability, indemnification, and dispute resolution."
        },
        "disclaimer": {
          "title": "11. Disclaimer of Warranties",
          "content": "THE SERVICE IS PROVIDED ON AN \"AS IS\" AND \"AS AVAILABLE\" BASIS. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, DASHBAL EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING BUT NOT LIMITED TO:\n\n• IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT\n• WARRANTIES REGARDING THE ACCURACY, RELIABILITY, COMPLETENESS, OR TIMELINESS OF DATA OBTAINED FROM THIRD-PARTY SOURCES (INCLUDING SHOPIFY, META, TIKTOK, AND WOOCOMMERCE)\n• WARRANTIES THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, SECURE, OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS\n• WARRANTIES REGARDING ANY AI-GENERATED INSIGHTS, FORECASTS, OR RECOMMENDATIONS\n\nSome jurisdictions do not allow exclusion of implied warranties. In such cases, the above exclusions apply to the maximum extent permitted by applicable law."
        },
        "liability": {
          "title": "12. Limitation of Liability",
          "content": "TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW:\n\n(A) IN NO EVENT SHALL DASHBAL, ITS DIRECTORS, OFFICERS, EMPLOYEES, AGENTS, PARTNERS, OR LICENSORS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, OR EXEMPLARY DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, REVENUE, DATA, GOODWILL, BUSINESS OPPORTUNITIES, OR BUSINESS INTERRUPTION, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.\n\n(B) DASHBAL'S TOTAL CUMULATIVE LIABILITY TO YOU FOR ALL CLAIMS ARISING OUT OF OR RELATING TO THESE TERMS OR THE SERVICE SHALL NOT EXCEED THE GREATER OF: (I) THE TOTAL FEES PAID BY YOU TO DASHBAL DURING THE TWELVE (12) MONTHS IMMEDIATELY PRECEDING THE CLAIM; OR (II) ONE HUNDRED U.S. DOLLARS (USD $100).\n\n(C) THE ABOVE LIMITATIONS APPLY REGARDLESS OF THE THEORY OF LIABILITY (CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, OR OTHERWISE) AND SHALL APPLY EVEN IF ANY LIMITED REMEDY FAILS OF ITS ESSENTIAL PURPOSE.\n\nSome jurisdictions do not allow certain liability limitations. In such cases, the above limitations apply to the maximum extent permitted by applicable law."
        },
        "indemnification": {
          "title": "13. Indemnification",
          "content": "You agree to defend, indemnify, and hold harmless Dashbal and its officers, directors, employees, contractors, agents, licensors, and successors from and against any and all third-party claims, damages, losses, liabilities, costs, and expenses (including reasonable attorneys' fees) arising out of or in connection with:\n\n• Your use of or inability to use the Service\n• Your User Data or content submitted through the Service\n• Your violation of these Terms or any applicable law or regulation\n• Your violation of any third-party rights, including intellectual property or privacy rights\n• Any misrepresentation made by you\n\nDashbal reserves the right, at its option, to assume exclusive control over the defense of any matter subject to indemnification by you (at your cost), and you agree to cooperate with our defense of such claims."
        },
        "governing": {
          "title": "14. Governing Law and Dispute Resolution",
          "content": "Governing Law: These Terms are governed by and construed in accordance with the laws applicable in the jurisdiction where Dashbal is duly incorporated, without regard to its conflict of law provisions. The United Nations Convention on Contracts for the International Sale of Goods (CISG) does not apply.\n\nInformal Resolution: Before initiating any formal dispute, you agree to contact us at support@dashbal.com and attempt to resolve the matter informally for at least 30 days.\n\nJurisdiction: For disputes not resolved informally, you and Dashbal consent to the exclusive jurisdiction of the competent courts in the jurisdiction where Dashbal is registered.\n\nEU Consumer Rights: For users located in the European Union, nothing in these Terms affects your rights as a consumer under mandatory EU consumer protection law, including your right to bring claims before the courts of your country of domicile.\n\nClass Action Waiver: To the extent permitted by applicable law, you waive any right to participate in or bring claims on a class-action basis against Dashbal."
        },
        "general": {
          "title": "15. General Provisions",
          "content": "Entire Agreement: These Terms, together with our Privacy Policy and any additional agreements, constitute the entire agreement between you and Dashbal regarding the Service.\n\nSeverability: If any provision of these Terms is found to be unenforceable or invalid, that provision shall be modified to the minimum extent necessary, and the remaining provisions shall continue in full force.\n\nWaiver: Our failure to enforce any right or provision of these Terms does not constitute a waiver of those rights.\n\nAssignment: You may not assign or transfer your rights under these Terms without our prior written consent. Dashbal may assign these Terms without restriction.\n\nForce Majeure: Dashbal shall not be liable for delays or failures in performance arising from causes beyond our reasonable control, including acts of God, natural disasters, government actions, cyberattacks, or third-party service failures.\n\nNotices: Notices to Dashbal must be sent to support@dashbal.com. Notices to you will be sent to the email address associated with your account."
        },
        "changes": {
          "title": "16. Changes to These Terms",
          "content": "We reserve the right to modify these Terms at any time. If a revision is material, we will provide at least 30 days' notice before the new Terms take effect — by email to your registered address and/or by a prominent notice on our website.\n\nYour continued use of the Service after revised Terms take effect constitutes your acceptance of the changes. If you do not agree to the revised Terms, you must stop using the Service before the effective date."
        },
        "contact": {
          "title": "17. Contact Us",
          "content": "For questions about these Terms of Service, please contact:\n\nDashbal Support Team\nEmail: support@dashbal.com\nWebsite: https://dashbal.com/terms\n\nFor privacy-related inquiries: privacy@dashbal.com"
        }
      }
    },
    "privacy": {
      "title": "Privacy Policy",
      "sections": {
        "intro": {
          "title": "1. Introduction",
          "content": "Dashbal (\"we,\" \"our,\" or \"us\") is committed to protecting your personal data and respecting your privacy. This Privacy Policy explains how we collect, use, store, share, and protect your information when you access or use the Dashbal platform, website, and related services (collectively, the \"Service\").\n\nBy registering for or using the Service, you acknowledge that you have read and understood this Privacy Policy. If you do not agree, please do not use the Service.\n\nData Controller: Dashbal\nPrivacy Contact: privacy@dashbal.com"
        },
        "collection": {
          "title": "2. Information We Collect",
          "content": "We collect the following categories of personal data:\n\nAccount & Identity Data\n• Name, email address, and encrypted password\n• Social login identifiers (Google ID, Facebook ID, Apple ID, TikTok ID)\n• Country, timezone, and currency preferences\n\nCommerce & Channel Data\n• Data from platforms you connect (Shopify, WooCommerce, Meta, TikTok): orders, transactions, products, advertising metrics, campaign data\n• OAuth access tokens and API credentials (encrypted at rest)\n\nFinancial & Billing Data\n• Subscription status, plan information, and billing history\n• Payment processed by Stripe (we do not store full card numbers)\n\nUsage & Activity Data\n• Feature interactions, session events, and analytics events\n• IP address, browser type, operating system, and user agent\n• Comprehensive activity logs including timestamps of all actions\n\nAI & Document Data\n• Content submitted to AI analysis features\n• AI usage logs including token counts\n• Documents uploaded for analysis (processed via Microsoft Azure)\n\nCommunication Data\n• Email engagement metrics (open/click tracking)\n• Support and customer service communications"
        },
        "legalBasis": {
          "title": "3. Legal Basis for Processing (GDPR)",
          "content": "If you are located in the European Economic Area (EEA), United Kingdom, or Switzerland, we process your personal data under the following legal bases per Article 6 of the GDPR:\n\n• Contractual Necessity (Art. 6(1)(b)): Processing required to provide the Service, manage your account, process payments, and perform our contract with you.\n\n• Legitimate Interests (Art. 6(1)(f)): Service security and fraud prevention, product improvement, activity logging, and analytics — where these interests are not overridden by your rights.\n\n• Consent (Art. 6(1)(a)): For non-essential cookies and optional marketing communications. You may withdraw consent at any time without affecting the lawfulness of prior processing.\n\n• Legal Obligation (Art. 6(1)(c)): Where required to comply with applicable laws, tax regulations, financial reporting requirements, or legal processes."
        },
        "usage": {
          "title": "4. How We Use Your Information",
          "content": "We use the information we collect to:\n\n• Provide, operate, and maintain the Service\n• Authenticate you and manage session security\n• Process payments and manage your subscription\n• Aggregate and display analytics from your connected channels\n• Power AI-driven insights and document analysis features\n• Send transactional emails, security alerts, and support communications\n• Monitor for abuse, fraud, and security threats\n• Improve and develop new features (using aggregated and anonymized data)\n• Comply with legal obligations and enforce our Terms of Service\n\nWe do not use your personal data for solely automated decision-making that produces legal or similarly significant effects without human review (as required by GDPR Article 22)."
        },
        "sharing": {
          "title": "5. Data Sharing and Sub-Processors",
          "content": "We do not sell your personal data. We may share data only as follows:\n\nService Providers (Sub-Processors bound by Data Processing Agreements):\n• Stripe, Inc. — Payment processing and billing\n• Google LLC (Gemini API) — AI-powered analytics and insights\n• Microsoft Azure (Document Intelligence & Blob Storage) — Document analysis and secure file storage\n• Resend — Transactional email delivery\n• ipinfo.io — IP-based geolocation lookup\n• Cloud infrastructure provider — Database hosting and server infrastructure\n\nThird-Party Platform APIs (user-initiated only):\n• Shopify, Meta (Facebook/Instagram), TikTok, WooCommerce — Data is retrieved solely on your behalf from platforms you explicitly connect.\n\nLegal Disclosures:\nWe may disclose your information if required by law, court order, or to protect the rights, property, or safety of Dashbal, our users, or the public.\n\nBusiness Transfers:\nIn the event of a merger, acquisition, or sale of assets, your data may be transferred. We will notify you in advance.\n\nAll sub-processors are contractually bound to provide equivalent data protection."
        },
        "storage": {
          "title": "6. Data Security",
          "content": "We implement industry-standard technical and organizational security measures, including:\n\n• AES-256 encryption for sensitive credentials and OAuth tokens at rest\n• bcrypt password hashing with adaptive cost factors\n• Short-lived JWT access tokens (15-minute expiry) with secure HTTP-only refresh tokens\n• HTTPS/TLS encryption for all data in transit\n• Rate limiting and adaptive brute-force protection on authentication endpoints\n• CSRF protection via time-limited state tokens\n• HTTP security headers (Helmet.js)\n• Comprehensive audit logs of all user and system actions\n\nDespite these measures, no system is immune to security breaches. In the event of a data breach affecting your rights and freedoms, we will notify you and relevant supervisory authorities as required by applicable law (within 72 hours for GDPR purposes)."
        },
        "retention": {
          "title": "7. Data Retention",
          "content": "We retain personal data for the following periods:\n\n• Account data: Retained while your account is active, plus up to 90 days after deletion to allow recovery and fulfill legal obligations\n• Transaction and billing records: Retained for 7 years to comply with accounting and tax regulations\n• Activity and access logs: Retained for up to 12 months, then automatically purged\n• Analytics events: Retained for up to 24 months\n• AI usage logs: Retained for up to 12 months\n• Email engagement data: Retained for up to 24 months\n\nUpon account deletion, personal data is deleted or anonymized, except where retention is required by applicable law. You may request earlier deletion by contacting privacy@dashbal.com."
        },
        "cookies": {
          "title": "8. Cookies and Tracking Technologies",
          "content": "We use cookies and similar technologies to operate and improve the Service:\n\nEssential Cookies: Required for authentication, session management, and core Service functionality. These cannot be disabled as they are necessary for the Service to function.\n\nAnalytics Cookies: Help us understand how users interact with the Service. Collected data is aggregated and anonymized where possible.\n\nPreference Cookies: Remember your settings and preferences (e.g., language, theme, display options).\n\nMarketing Cookies: Used only with your prior explicit consent to deliver relevant content and advertising.\n\nYou may manage your cookie preferences at any time using the Cookie Settings option available on our website. Withdrawing consent for non-essential cookies may limit certain Service functionality.\n\nFor users in France, our cookie consent interface is designed in compliance with CNIL guidelines, providing equal prominence to \"Accept\" and \"Refuse\" options."
        },
        "rights": {
          "title": "9. Your Privacy Rights",
          "content": "Depending on your location, you have the following rights:\n\nEU/EEA, UK, and Switzerland (GDPR / UK GDPR):\n• Right of Access (Art. 15): Obtain a copy of your personal data\n• Right to Rectification (Art. 16): Correct inaccurate or incomplete data\n• Right to Erasure — \"Right to be Forgotten\" (Art. 17): Request deletion of your data\n• Right to Data Portability (Art. 20): Receive your data in a structured, machine-readable format\n• Right to Restrict Processing (Art. 18): Pause how we use your data while a dispute is resolved\n• Right to Object (Art. 21): Object to processing based on legitimate interests\n• Right to Lodge a Complaint: Contact your national data protection authority (e.g., CNIL in France, ICO in the United Kingdom)\n\nCalifornia Residents (CCPA/CPRA):\n• Right to Know: Categories and specific pieces of personal information collected\n• Right to Delete: Request deletion of personal information\n• Right to Correct: Request correction of inaccurate personal information\n• Right to Opt-Out: We do not sell or share personal information for cross-context behavioral advertising\n• Right to Non-Discrimination: We will not discriminate against you for exercising your privacy rights\n\nCanadian Residents (PIPEDA / Quebec Law 25):\n• Right of access, correction, and withdrawal of consent for non-essential processing\n• Quebec residents have an additional right to de-indexing of certain personal information\n\nTo exercise any of these rights, contact us at privacy@dashbal.com. We will respond within 30 days (or within the timeframe required by applicable law)."
        },
        "international": {
          "title": "10. International Data Transfers",
          "content": "Dashbal operates globally and your data may be transferred to and processed in countries other than your country of residence, including countries that may not provide the same level of data protection.\n\nWhen we transfer personal data from the European Economic Area, United Kingdom, or Switzerland to third countries, we use appropriate safeguards, including:\n\n• EU-U.S. Data Privacy Framework (DPF): Where applicable, we rely on the DPF adequacy decision adopted by the European Commission (July 10, 2023) for transfers to certified U.S. processors.\n\n• Standard Contractual Clauses (SCCs): For transfers not covered by the DPF, we use the Standard Contractual Clauses adopted pursuant to Commission Implementing Decision (EU) 2021/914 of 4 June 2021.\n\n• UK International Data Transfer Agreements (IDTA): For transfers from the United Kingdom, we use the IDTA approved by the UK Secretary of State or the EU SCCs with the UK Addendum (pursuant to Section 119A of the Data Protection Act 2018).\n\n• Transfer Impact Assessments (TIAs): We conduct TIAs where required to supplement the above mechanisms.\n\nBy using the Service, you acknowledge that your data may be transferred internationally in accordance with the safeguards described above."
        },
        "children": {
          "title": "11. Children's Privacy",
          "content": "The Service is intended solely for users aged 18 and older. We do not knowingly collect personal information from individuals under the age of 18.\n\nIf we become aware that we have collected personal data from a minor without verifiable parental consent, we will delete it immediately.\n\nIf you are a parent or guardian and believe your child has provided us with personal information, please contact us at privacy@dashbal.com."
        },
        "changes": {
          "title": "12. Changes to This Privacy Policy",
          "content": "We may update this Privacy Policy from time to time to reflect changes in our practices, technology, legal requirements, or other factors.\n\nFor material changes, we will provide at least 30 days' notice before the revised policy takes effect by:\n• Sending an email to the address associated with your account\n• Displaying a prominent notice on our website\n\nYour continued use of the Service after the effective date of the revised Privacy Policy constitutes your acceptance of the changes. If you do not agree to the changes, you must stop using the Service before the effective date."
        },
        "contact": {
          "title": "13. Contact Us",
          "content": "For questions, requests, or concerns about this Privacy Policy or our data practices, please contact:\n\nData Privacy Team\nEmail: privacy@dashbal.com\nWebsite: https://dashbal.com/privacy\n\nIf you are located in the EU/EEA and are not satisfied with our response, you have the right to lodge a complaint with your local data protection authority (e.g., CNIL in France: www.cnil.fr; ICO in the UK: ico.org.uk)."
        },
        "dataDeletion": {
          "title": "14. Data Deletion Instructions",
          "content": "To request deletion of your data and your Dashbal account, you can follow these steps:\n\n1. Log in to your Dashbal account.\n2. Go to Settings (Profile icon) > Privacy tab.\n3. Scroll to the 'Danger Zone' section and click 'Delete Account & Data'.\n4. Confirm the deletion in the modal.\n\nAlternatively, you can send an email to privacy@dashbal.com with the subject 'Data Deletion Request' from the email address associated with your account. We will process your request within 30 days and permanently remove all your data, including data collected via the Meta (Facebook) platform. This fulfills the requirements of the Meta Platform Terms regarding User Data Deletion."
        }
      }
    }
  },
  "gdpr": {
    "banner": {
      "title": "We value your privacy",
      "description": "We use cookies and similar technologies to provide you with the best possible experience. Some cookies are essential for the site to function, while others help us improve your experience and personalize content.",
      "learnMore": "Learn more about our privacy practices",
      "acceptAll": "Accept All",
      "rejectAll": "Reject All",
      "customize": "Customize Settings"
    },
    "preferences": {
      "title": "Cookie Preferences",
      "description": "Manage your cookie preferences. You can enable or disable different categories of cookies below. Note that disabling some cookies may impact your experience on the site.",
      "savePreferences": "Save Preferences"
    },
    "categories": {
      "necessary": {
        "title": "Essential Cookies",
        "description": "These cookies are required for basic site functionality like page navigation, secure access, and remembering your preferences. The site cannot function properly without them."
      },
      "analytics": {
        "title": "Analytics Cookies",
        "description": "These cookies help us understand how visitors interact with our website by collecting and reporting anonymous information. This helps us improve site performance and user experience."
      },
      "marketing": {
        "title": "Marketing Cookies",
        "description": "These cookies are used to track visitors across websites to display relevant advertisements. They remember that you visited our site and may share this information with advertising partners."
      },
      "preferences": {
        "title": "Preference Cookies",
        "description": "These cookies allow the website to remember choices you make (such as your language or the region you are in) and provide enhanced, personalized features."
      }
    },
    "required": "Required",
    "managePreferences": "Cookie Settings"
  },
  "sync": {
    "connecting": "Connecting...",
    "authenticating": "Authenticating...",
    "requesting_data": "Requesting data...",
    "waiting": "Waiting...",
    "receiving": "Receiving...",
    "verifying": "Verifying...",
    "analyzing": "Analyzing...",
    "processing": "Processing...",
    "mapping": "Mapping...",
    "finalizing": "Finalizing...",
    "analyzing_customers": "Analyzing customers...",
    "detecting_currencies": "Detecting currencies...",
    "calculating_ranges": "Calculating ranges...",
    "syncing_data": "Syncing data...",
    "fetching_data": "Fetching data...",
    "querying_api": "Querying API...",
    "retrieving": "Retrieving..."
  },
  "entityTypes": {
    "adaccount": "Ad Account",
    "campaign": "Campaign",
    "adset": "Ad Set",
    "adgroup": "Ad Group",
    "ad": "Ad",
    "product": "Product",
    "coupon": "Coupon",
    "campaign_one": "campaign",
    "campaign_other": "campaigns",
    "adaccount_one": "ad account",
    "adaccount_other": "ad accounts",
    "adset_one": "ad set",
    "adset_other": "ad sets",
    "adgroup_one": "ad group",
    "adgroup_other": "ad groups",
    "ad_one": "ad",
    "ad_other": "ads",
    "product_one": "product",
    "product_other": "products",
    "coupon_one": "coupon",
    "coupon_other": "coupons"
  },
  "channelEvents": {
    "shopify": {
      "product": {
        "updated": "Product Updated",
        "destroyed": "Product Removed",
        "published": "Product Published",
        "unpublished": "Product Unpublished",
        "status_changed": "Product Status Changed"
      },
      "order": {
        "placed": "Order Placed",
        "confirmed": "Order Confirmed",
        "cancelled": "Order Cancelled",
        "closed": "Order Closed",
        "reopened": "Order Reopened",
        "fulfilled": "Order Fulfilled",
        "fulfillment_cancelled": "Fulfillment Cancelled",
        "refund_success": "Refund Issued"
      },
      "collection": {
        "updated": "Collection Updated",
        "destroyed": "Collection Removed",
        "published": "Collection Published",
        "unpublished": "Collection Unpublished"
      },
      "article": {
        "updated": "Article Updated",
        "destroyed": "Article Removed"
      },
      "blog": {
        "updated": "Blog Updated",
        "destroyed": "Blog Removed"
      },
      "page": {
        "updated": "Page Updated",
        "destroyed": "Page Removed"
      },
      "price_rule": {
        "updated": "Discount Updated",
        "destroyed": "Discount Removed"
      }
    },
    "meta": {
      "campaign": {
        "status_updated": "Campaign Status Changed",
        "budget_updated": "Campaign Budget Changed",
        "schedule_updated": "Campaign Schedule Changed",
        "ended": "Campaign Ended",
        "spend_cap_updated": "Campaign Spend Cap Changed"
      },
      "adset": {
        "status_updated": "Ad Set Status Changed",
        "budget_updated": "Ad Set Budget Changed",
        "bidding_updated": "Ad Set Bidding Changed",
        "bid_strategy_updated": "Ad Set Bid Strategy Changed",
        "targeting_updated": "Ad Set Targeting Changed",
        "schedule_updated": "Ad Set Schedule Changed"
      },
      "ad": {
        "status_updated": "Ad Status Changed",
        "creative_updated": "Ad Creative Changed",
        "review_approved": "Ad Review Approved",
        "review_declined": "Ad Review Declined"
      },
      "account": {
        "status_updated": "Account Status Changed",
        "spend_limit_updated": "Account Spend Limit Changed",
        "spend_limit_reset": "Account Spend Limit Reset",
        "spend_limit_removed": "Account Spend Limit Removed"
      }
    },
    "unknown": "Event"
  },
  "upgrade": {
    "defaultTitle": "Plan Limit Reached",
    "defaultDescription": "Upgrade your plan to unlock more.",
    "currentPlan": "Current Plan",
    "noSubscription": "No subscription",
    "freePlan": "Free Plan",
    "usage": "Usage",
    "dismiss": "Maybe later",
    "cta": "View Plans"
  },
  "pages": {
    "traffic": {
      "title": "Traffic Attribution",
      "subtitle": "Analyze how each channel contributes to your total revenue.",
      "aiDiagnosis": "AI Traffic Analysis",
      "trafficVerdict": "Attribution Verdict",
      "topRecommendation": "Growth Opportunity",
      "applyOptimization": "Scale Channel",
      "verdictPlaceholder": "Your <0>{{channel}}</0> attribution has increased by <1>{{percent}}%</1> this period. It is currently your most efficient revenue driver.",
      "recommendationPlaceholder": "Increasing social ad spend by 15% could yield an estimated {{revenue}} in additional revenue based on current conversion patterns.",
      "kpis": {
        "totalRevenue": "Total Revenue",
        "organicRevenue": "Organic Revenue",
        "paidRevenue": "Paid Revenue",
        "conversionRate": "Conv. Rate",
        "topChannel": "Top Channel"
      },
      "table": {
        "source": "Traffic Source",
        "attribution": "Attribution %",
        "revenue": "Revenue",
        "trend": "Trend",
        "availableStreams": "Available Streams",
        "volume": "Volume",
        "action": "Action",
        "performanceSource": "Performance Source",
        "revenueValue": "Revenue Value",
        "sharePercent": "% Share",
        "connectivityStatus": "Connectivity Status",
        "paid": "Paid",
        "organic": "Organic",
        "noDataLinkAnalysis": "No data available for Link Analysis",
        "metrics": "Metrics",
        "total": "TOTAL",
        "periodTotal": "PERIOD TOTAL",
        "attributionLabel": "Attribution"
      },
      "activeFocus": "Active Focus",
      "distribution": "Revenue Distribution",
      "periodDistribution": "Period Revenue Distribution",
      "modals": {
        "organicTitle": "Organic Performance",
        "organicDescription": "This revenue is generated from your organic sources and is automatically integrated into your dashboard.",
        "platformLinkTitle": "Platform Link",
        "platformLinkDescription": "{{name}} accounts for {{percent}}% of this revenue. A source limitation currently prevents direct deep-linking to this specific campaign.",
        "platforms": {
          "directOrganic": "Direct / Organic"
        },
        "generalSales": "General Sales",
        "unmatchedSource": "Unmatched {{source}}",
        "unmatchedSourceWithId": "Unmatched {{source}} (ID:{{id}})",
        "unavailableTooltip": "(unavailable, connect ?)",
        "untrackedLabel": "Untracked",
        "unknownSourceLabel": "Unknown Source",
        "unknownChannel": "Unknown",
        "disconnectedLabel": "is disconnected"
      },
      "totalSourceRevenue": "Total Source Revenue"
    },
    "cashflow": {
      "title": "Cash Flow",
      "dailyBreakdown": "Daily Breakdown",
      "kpis": {
        "netProfit": "Net Cash Flow",
        "mer": "MER (Blended ROAS)",
        "avgDaily": "Avg Daily Net",
        "opex": "Total OpEx"
      },
      "verdict": {
        "title": "Cash Flow Verdict",
        "subtitle": "Strategic Analysis",
        "positive": "Your business is currently <0>Cashflow Positive</0>. With a MER of <1>{{mer}}x</1>, you have room to optimize efficiency.",
        "negative": "Your business is currently <0>Negative Cashflow</0>. Focus on reducing non-essential OpEx.",
        "recommendationPositive": "Target 10% ROAS increase to capture volume.",
        "recommendationNegative": "Renegotiate supplier terms for better cash flow.",
        "mobilePositive": "Your business is currently <0>Cashflow Positive</0>. With a MER of <1>{{mer}}x</1>, you have room to scale.",
        "mobileNegative": "Your business is currently <0>Negative Cashflow</0>. Focus on efficiency.",
        "mobileRecPositive": "Scale top performing channels.",
        "mobileRecNegative": "Optimize operational expenses."
      }
    },
    "forecast": {
      "title": "Forecast",
      "empty": {
        "title": "Gathering Historical Data",
        "description": "Forecasting requires a baseline of historical performance. Connect your store and marketing channels to start visualizing your future patterns.",
        "monitoring": "Monitoring Signals",
        "notEnoughData": "Not Enough Data",
        "needMoreHistory": "We need more historical data for this product to generate a reliable forecast.",
        "notYesterdayTitle": "Adjusting Your View",
        "notYesterdayDescription": "Forecasting is only available when analyzing data up to yesterday to ensure data finality. Please adjust your range to end on the previous day.",
        "noDataTitle": "Insufficient Data for Forecasting",
        "noDataDescription": "We don't have enough historical data to generate a reliable forecast. Connect more sources or wait for more data to accumulate."
      },
      "distribution": {
        "title": "Revenue Distribution (Forecasted)"
      },
      "controls": {
        "historical": "Historical:",
        "forecast": "Forecast:",
        "window": "Forecast Window",
        "debug": "Debug Charts"
      },
      "kpis": {
        "forecastedRevenue": "Forecasted Revenue",
        "statisticalAccuracy": "Statistical Accuracy",
        "expectedTotal": "Expected Total"
      },
      "sources": {
        "title": "Forecasted Sources",
        "paidSuffix": " - Paid",
        "forecast": "Forecast"
      },
      "charts": {
        "roas": "ROAS",
        "actualRoas": "Actual ROAS",
        "predictedRoas": "Predicted ROAS",
        "upperBound": "Upper Bound",
        "lowerBound": "Lower Bound",
        "actualRevenue": "Actual Revenue",
        "forecast": "Forecast",
        "actualValue": "Actual Value",
        "predictedValue": "Predicted Value",
        "bottomUpTransformation": "Bottom-Up Transformation",
        "accurateSummation": "Accurate Summation",
        "combinedRevenue": "Combined Total Revenue",
        "revenueTransformationDesc": "Generated by transforming per-source ROAS targets into revenue based on manual spend targets and organic trends. Reflects all optimism and jitter adjustments.",
        "totalCostOperations": "Total Cost of Operations",
        "actualExpense": "Actual Expense",
        "predictedExpense": "Predicted Expense",
        "expenseAggregateDesc": "Aggregate of all marketing spend, journal entries, calculated specs (taxes/fees), and operational general expenses. Includes seasonality and adaptive jitter for realism.",
        "nonPaidForecasts": "Non-Paid Revenue Forecasts",
        "unknownSourceRevenue": "Unknown Source Revenue",
        "combinedRoasTrajectory": "Combined ROAS Trajectory",
        "combinedNonPaidRevenue": "Combined Non-Paid Revenue",
        "manualEntries": "Manual Entries",
        "boardSpecs": "Board Specs",
        "untrackedLabel": "Untracked / Disconnected",
        "forecastedRevenue": "Forecasted Revenue",
        "perSourceRoas": "Per-Source ROAS Forecast",
        "expensesForecast": "Expenses Forecast",
        "predictedRevenue": "Predicted Revenue"
      },
      "sections": {
        "nonPaidRevenue": "Non-Paid Revenue Forecasts"
      },
      "verdict": {
        "title": "Prediction Verdict",
        "growth": "Expected Growth",
        "steady": "Stable Trajectory",
        "summary": "Based on {{count}} days of data, projected revenue: {{revenue}} over {{days}} days.",
        "variance": "Expected Variance Range",
        "margin": "±{{percent}}% margin",
        "pessimistic": "Pessimistic Estimate",
        "optimistic": "Optimistic Estimate"
      },
      "product": {
        "stats": "{{name}} Stats",
        "revenueForecast": "Revenue Forecast",
        "revenueProjection": "Revenue Projection",
        "noRevenueData": "No Revenue Data Found",
        "noRevenueDataDesc": "This product doesn't have enough tracked revenue yet to generate a forecast. Revenue will appear as records are updated.",
        "noDetailedData": "No detailed data",
        "noDetailedDataDesc": "Could not map any tracked campaigns to this revenue source.",
        "noRevenueDataAvailable": "No Revenue Data Available",
        "noRevenueDataAvailableDesc": "Not enough spend or revenue data linked to this ad source to compute a revenue forecast.",
        "noOrganicData": "No Organic Revenue Data",
        "noOrganicDataDesc": "This product hasn't generated enough organic revenue yet for a reliable forecast.",
        "organicRevenue": "Organic Revenue ({{source}})",
        "revenueForecastTitle": "Revenue Forecast ({{source}})",
        "accuracy": "{{percent}}% Accuracy",
        "limitedData": "Limited Data",
        "forecast": "Forecast"
      },
      "accuracy": {
        "title": "Statistical Accuracy",
        "reliabilityLabel": "Forecast Reliability",
        "percentage": "{{score}}% Accuracy",
        "verdicts": {
          "good": "Good — Enough stable data to produce a meaningful forecast.",
          "moderate": "Moderate — Some data gaps. Treat as a rough directional estimate.",
          "low": "Low — Very limited data. This forecast is a best-effort guess, not a reliable prediction."
        },
        "backtest": {
          "label": "Backtest",
          "title": "Historical Backtest",
          "body": "How well our model predicts recent historical data. Higher is better."
        },
        "quality": {
          "label": "Data Quality",
          "title": "Data Integrity",
          "body": "Measures gaps and outliers in your historical revenue data."
        },
        "fidelity": {
          "label": "Slider Fidelity",
          "title": "Adjustment Impact",
          "body": "How much your manual slider adjustments deviate from the AI baseline."
        },
        "horizon": {
          "label": "Horizon",
          "title": "Forecast Horizon",
          "body": "Accuracy naturally decays as we look further into the future."
        },
        "coverage": {
          "label": "Coverage",
          "title": "Source Coverage",
          "body": "Percentage of revenue sources that have enough data to be statistically modeled."
        },
        "sources": {
          "title": "Tested Sources",
          "body": "Number of revenue sources with enough history for backtesting vs total sources."
        }
      },
      "ai": {
        "context": "AI Context: {{reason}}"
      },
      "phases": {
        "learning": "Learning",
        "scaling": "Scaling",
        "stabilizing": "Stabilizing",
        "sunset": "Sunset",
        "testing": "Testing",
        "paused": "Paused"
      }
    },
    "performance": {
      "title": "Performance Analysis",
      "kpiMetrics": "KPI Metrics",
      "total": "TOTAL",
      "periodTotal": "PERIOD TOTAL",
      "aiInsight": "AI Insight Analysis",
      "performanceVerdict": "Performance Verdict",
      "topRecommendation": "Top Recommendation",
      "applyOptimization": "Apply Optimization",
      "helpfulTrend": "HELPFUL TREND",
      "verdictPlaceholder": "Our AI is currently analyzing your performance data. We found a <0>{{percent}}% improvement</0> in your AOV compared to last month.",
      "recommendationPlaceholder": "Your ROAS is peaking on Fridays. Consider increasing ad spend for weekends to maximize conversion volume.",
      "kpis": {
        "grossSales": {
          "title": "Gross Sales",
          "desc": "Total value of all sales before any deductions for discounts or returns."
        },
        "netSales": {
          "title": "Net Sales",
          "desc": "The actual revenue from product sales after accounting for discounts and returns."
        },
        "revenue": {
          "title": "Total Revenue",
          "desc": "The total amount of money generated by all business activities (sales, shipping, etc.)."
        },
        "expenses": {
          "title": "Total Expenses",
          "desc": "Complete operational costs including product costs, shipping, marketing, and fees."
        },
        "net": {
          "title": "Net Cash Flow",
          "desc": "The remaining profit after all expenses have been subtracted from total revenue."
        },
        "margin": {
          "title": "Profit Margin",
          "desc": "The percentage of revenue that remains as profit after all costs are covered."
        },
        "orders": {
          "title": "Orders",
          "desc": "The total number of unique orders processed within the selected timeframe."
        },
        "aov": {
          "title": "AOV",
          "desc": "Average Order Value: The average amount spent by a customer per purchase."
        },
        "discountRate": {
          "title": "Discount Rate",
          "desc": "The total value of discounts given as a percentage of gross sales."
        },
        "returnRate": {
          "title": "Return Rate",
          "desc": "The value of returned products as a percentage of your total gross sales."
        },
        "shippingRevenue": {
          "title": "Shipping Rev.",
          "desc": "Total revenue collected from customers for shipping and handling."
        },
        "transactionFees": {
          "title": "Tx Fees",
          "desc": "Fees paid to payment processors (like Stripe, PayPal) for handling payments."
        },
        "txFeePercent": {
          "title": "Tx Fee %",
          "desc": "The average cost of payment processing as a percentage of total revenue."
        },
        "customers": {
          "title": "Customers",
          "desc": "The number of unique individuals who placed an order during this period."
        },
        "avgRevenuePerCustomer": {
          "title": "Rev/Customer",
          "desc": "The average lifetime or period revenue generated per unique customer."
        },
        "roas": {
          "title": "ROAS",
          "desc": "Return on Ad Spend: Revenue generated for every dollar invested in advertising."
        },
        "cac": {
          "title": "CAC",
          "desc": "Customer Acquisition Cost: The marketing spend required to acquire a new customer."
        },
        "adSpendPercent": {
          "title": "Ad Spend %",
          "desc": "Total marketing and advertising expenditure as a percentage of total revenue."
        }
      }
    },
    "unableToRename": "Unable to rename page. Please try again.",
    "unableToDelete": "Unable to delete page. Please try again.",
    "unableToReorder": "Unable to reorder pages. Please try again.",
    "unableToSaveLayout": "Unable to save board layout. Please try again."
  },
  "verdicts": {
    "tabs": {
      "llm": "Deep Analysis"
    },
    "empty": {
      "title": "Gathering Signals",
      "message": "Connect your channels or add historical data to allow the AI to generate a verdict."
    },
    "labels": {
      "aiInsight": "AI Insight",
      "recommendation": "Top Recommendation",
      "missingSources": "Missing for Full Analysis:",
      "aiChat": "Deep AI Analysis",
      "strategicInsights": "Strategic Assessment:"
    },
    "actions": {
      "analyzing": "Analysing...",
      "startAnalysis": "Trigger Deep Analysis",
      "retry": "Try Again",
      "askAiMore": "Ask AI more about this..."
    },
    "llm": {
      "trigger": {
        "title": "Deep AI Analysis",
        "desc": "Activate the AI multi-source correlation engine to find hidden cross-channel growth opportunities."
      },
      "analysisTitle": "AI Executive Summary"
    },
    "performance": {
      "EMPTY_STATE": {
        "title": "Gathering Signals",
        "message": "Connect your channels or add historical data to allow the AI to generate a verdict.",
        "recommendation": "Connect Shopify, WooCommerce or add manual journals to start analysis."
      },
      "EFFICIENT_SCALING": {
        "title": "Efficient Scaling Opportunity",
        "message": "Your margin is a strong {{margin}}% and ROAS is efficient at {{roas}}x. Revenue grew {{revGrowth}}%.",
        "recommendation": "Increase ad spend in top-performing campaigns to capture more volume."
      },
      "MARGIN_CRUNCH": {
        "title": "Profit Margin Crunch",
        "message": "Revenue is up by {{revGrowth}}%, but margins have dropped to {{margin}}%.",
        "recommendation": "Review processing fees and ad spend efficiency; prioritize high-margin products."
      },
      "REVENUE_DROP_ALARM": {
        "title": "Revenue Drop Alert",
        "message": "Revenue has decreased by {{revGrowth}}% compared to last period. Profits are down {{profitDelta}}%.",
        "recommendation": "Audit conversion rates and active marketing campaigns for potential issues."
      }
    },
    "traffic": {
      "EMPTY_STATE": {
        "title": "Gathering Momentum",
        "message": "Zero traffic or revenue recorded for this period.",
        "recommendation": "Check your Google Ads or Meta Ads integration to ensure tracking is active."
      },
      "ORGANIC_OVERPOWERING": {
        "title": "Strong Organic Performance",
        "message": "Your business has high leverage! {{organicPercent}}% of your revenue is from organic channels.",
        "recommendation": "This is a perfect time to scale paid traffic gradually while keeping your CAC low."
      },
      "PAID_ADDICTION": {
        "title": "High Paid Dependency",
        "message": "{{paidPercent}}% of your traffic is paid, while revenue growth is only {{growth}}%.",
        "recommendation": "Invest in SEO and email marketing to build long-term organic equity."
      }
    },
    "forecast": {
      "EMPTY_STATE": {
        "title": "Forecasting Data Required",
        "message": "Insufficient historical data to generate reliable growth models.",
        "recommendation": "Ensure at least 30 days of historical data is synced for accurate forecasting."
      },
      "GROWTH_AHEAD": {
        "title": "Sustained Growth Forecast",
        "message": "Data trends suggest a {{projectedGrowth}}% increase in revenue over the next 30 days.",
        "recommendation": "Ensure inventory readiness and plan for increased logistics capacity."
      }
    },
    "cash flow": {
      "EMPTY_STATE": {
        "title": "Analyzing Cash Cycles",
        "message": "Cash flow data is pending normalization across your journals and accounts.",
        "recommendation": "Link your main bank journals or accounting platforms for real-time flow analysis."
      },
      "HEALTHY_RESERVES": {
        "title": "Strong Cash Position",
        "message": "Your current net flow is positive with {{ratio}}x coverage of fixed expenses.",
        "recommendation": "Consider reinvesting surplus cash into growth-oriented R&D or expansion."
      }
    },
    "errors": {
      "quota_exceeded": "Weekly Analysis Limit Reached",
      "quota_exceeded_desc": "You have used all your AI Deep Analysis tokens for this week.",
      "upgrade_plan": "Upgrade to a Pro plan to unlock unlimited executive insights.",
      "reset_soon": "Your quota will begin to reset within the next hour.",
      "reset_hours": "Your quota will begin to reset in approximately {{hours}} hours.",
      "reset_days": "Your quota will begin to reset in a few days.",
      "quota_exceeded_default": "Your weekly AI quota is currently exhausted.",
      "service_issue": "AI is momentarily resting",
      "service_issue_desc": "We encountered a temporary issue while generating your deep analysis. Please try again in a few moments.",
      "default": "Our AI strategist is currently unavailable. Please try again in a moment.",
      "quota": "Your strategic analysis quota for this week has been reached.",
      "notFound": "We couldn't find the requested analysis.",
      "rateLimit": "Too many requests. Please wait a few seconds."
    }
  },
  "onboarding": {
    "welcome": {
      "title": "Welcome to Dashbal!",
      "description": "Let's get you set up. We'll guide you through the key steps to start visualizing your financial data."
    },
    "createBoard": {
      "title": "Create Your First Board",
      "description": "Start by creating a workspace where you'll bring together all your data."
    },
    "addData": {
      "title": "Connect Your Data",
      "description": "Connect platforms like Shopify or create a Money Journal to track manual entries and cash flows."
    },
    "setDateRange": {
      "title": "Set Date Range",
      "description": "Click the calendar to align all metrics with a specific timeframe."
    },
    "addSpec": {
      "title": "Create a Board Spec",
      "description": "Define custom formulas to transform your raw data into actionable insights and KPIs."
    },
    "completed": {
      "title": "All Set!",
      "description": "You've completed the initial setup. Now you can explore your data and grow your business."
    },
    "actions": {
      "next": "Got it!",
      "back": "Back",
      "skip": "Skip Tour",
      "finish": "Got it!"
    }
  },
  "modal": "register",
  "journalTab": "shared",
  "exportOperations": {
    "title": "Export Operations",
    "subtitle": "Choose the best format for your needs",
    "formats": {
      "csvExcel": "CSV for Excel",
      "csvExcelDesc": "Optimized for Excel, Numbers, and other spreadsheet tools",
      "csvPlain": "Plain CSV",
      "csvPlainDesc": "Standard comma-separated values file"
    }
  },
  "details": {
    "loading": "Loading details..."
  },
  "ai": {
    "status": {
      "executionStarted": "Execution started...",
      "executionComplete": "Execution complete.",
      "executionFailed": "Execution failed."
    }
  },
  "notices": {
    "syncSuccess": "Sync Finished: {{channelName}}",
    "syncError": "Sync Failed: {{channelName}}",
    "syncErrorCommercial": "We couldn't reach {{channelName}} to update your data.",
    "viewDetails": "View Details"
  },
  "syncErrorModal": {
    "title": "Connection issue with {{channelName}}",
    "message": "We've encountered a temporary hiccup while trying to fetch the latest updates from your **{{channelName}}** account.",
    "suggestion": "You might need to refresh your connection if it has expired, or simply wait a moment while the platform catches its breath.",
    "close": "Close"
  },
  "docs": {
    "title": "Documentation",
    "searchPlaceholder": "Search documentation...",
    "backToHome": "Back to Boards",
    "wasHelpful": "Was this helpful?",
    "thanksFeedback": "Thanks for your feedback!",
    "yes": "Yes",
    "no": "No",
    "lastUpdated": "Last updated on {{date}}",
    "categories": {
      "gettingStarted": "Getting Started",
      "boards": "Boards & Composer",
      "connections": "Data Connections",
      "moneyJournal": "Money Journal",
      "ai": "Dashbal AI",
      "specs": "Metrics & Specs",
      "charts": "Charts & Analytics",
      "collaboration": "Sharing & Collaboration",
      "billing": "Plans & Billing"
    },
    "articles": {
      "accountSetup": "Account Setup",
      "profileSecurity": "Profile & Security",
      "boardUsage": "Composer & Templates",
      "boardManagement": "Managing Boards",
      "addingPages": "Adding Pages to Boards",
      "connectingShopify": "Connecting Shopify",
      "connectingWooCommerce": "Connecting WooCommerce",
      "connectingAdChannels": "Connecting Ad Channels",
      "addingConnectionToBoard": "Linking Data to Boards",
      "creatingMoneyJournal": "Creating Journals",
      "droppingFiles": "AI File Dropping",
      "manualEntries": "Manual Entries",
      "talkingToAi": "Talking to Dashbal AI",
      "aiCapabilities": "AI Capabilities",
      "understandingSpecs": "Understanding Specs",
      "formulaSyntax": "Formula Syntax",
      "chartCategories": "Chart Categories Guide",
      "exportingData": "Exporting Data",
      "sharingBoards": "Sharing with Team",
      "billingLimits": "Plans & Billing",
      "planLimits": "AI Quotas & Limits"
    },
    "content": {
      "accountSetup": {
        "intro": "Welcome to Dashbal. Setting up your account is the first step towards unified financial visibility across all your sales channels and marketing platforms.",
        "registrationTitle": "1. Registration",
        "registrationContent": "Sign up using your business email or one of our supported social providers (Google, Apple, Meta). We recommend using your business email to simplify team collaboration and workspace management later on.",
        "verificationTitle": "2. Email Verification",
        "verificationContent": "After signing up, check your inbox for a verification link. This ensures your financial data remains secure and accessible only to you.",
        "proTipTitle": "Pro Tip",
        "proTipContent": "You can enable Two-Factor Authentication (2FA) immediately after login from your Profile Settings to add an extra layer of security."
      },
      "profileSecurity": {
        "intro": "Protecting your financial data is our top priority. Dashbal provides enterprise-grade security tools to keep your account safe.",
        "bestPracticesTitle": "Security Best Practices",
        "twoFactorTitle": "Use 2FA",
        "twoFactorContent": "Enable TOTP-based authentication (like Google Authenticator) for your account.",
        "sessionsTitle": "Monitor Sessions",
        "sessionsContent": "Regularly check 'Active Sessions' in your security settings to ensure no unauthorized access."
      },
      "boardManagement": {
        "intro": "Boards are the heart of Dashbal. They allow you to organize your data by business unit, region, or project.",
        "createTitle": "Creating a Board",
        "step1": "Click 'Create Board' from the Board Explorer sidebar.",
        "step2": "Give your board a descriptive name and choose its primary currency.",
        "step3": "Select a template or start from a blank canvas.",
        "note": "Note: You can duplicate boards to quickly replicate successful reporting structures across different stores."
      },
      "addingPages": {
        "intro": "Boards can contain multiple pages, allowing you to separate different types of analysis (e.g., 'Overview', 'Marketing', 'Operations') within a single workspace.",
        "manageTitle": "Managing Pages",
        "addTitle": "1. Add a New Page",
        "addContent": "Click the '+' icon in the page tabs bar at the bottom of your board. You can choose to start from a template or a blank page.",
        "renameTitle": "2. Rename or Delete",
        "renameContent": "Double-click a page tab to rename it, or right-click to see management options including 'Duplicate' and 'Delete'.",
        "reorderTitle": "3. Reorder",
        "reorderContent": "Simply drag and drop the page tabs to change their order."
      },
      "boardUsage": {
        "intro": "Dashbal boards feature a powerful Composer system. You can build bespoke reporting layouts using the 'Composer' page type, allowing for total flexibility in chart placement and sizing.",
        "interactionsTitle": "Using the Composer",
        "dragTitle": "Build Your Own",
        "dragContent": "Select the 'Composer' page type when creating a new page to unlock the custom layout engine.",
        "resizeTitle": "Templates First",
        "resizeContent": "Don't want to start from scratch? Use our expert-vetted templates to instantly populate a Composer page with the most critical KPIs for your business type."
      },
      "connectingShopify": {
        "intro": "As an official Shopify partner, Dashbal provides a seamless, one-click integration that syncs your orders, products, and fulfillment data.",
        "setupTitle": "Official App Installation",
        "step1": "Go to the 'Connect Channel' modal and select Shopify.",
        "step2": "Click 'Install Dashbal App' to be redirected to the Shopify App Store.",
        "step3": "Log in to your store and approve the required permissions. Dashbal will begin historical synchronization immediately."
      },
      "connectingWooCommerce": {
        "intro": "Connect your WooCommerce store using our high-performance WordPress connector plugin.",
        "setupTitle": "Plugin Installation Workflow",
        "step1": "Download the Dashbal Connector ZIP file from the WooCommerce connection screen.",
        "step2": "In your WordPress admin, go to Plugins > Add New > Upload Plugin and select the ZIP file.",
        "step3": "Activate the plugin and click 'Connect to Dashbal' to authorize the secure data stream."
      },
      "connectingAdChannels": {
        "intro": "Dashbal integrates with Meta (Facebook/Instagram), TikTok, and Google Ads using secure OAuth 2.0 protocols.",
        "setupTitle": "One-Click Authorization",
        "step1": "Select your ad platform from the 'Connect Channel' list.",
        "step2": "A secure popup will open asking you to log in to the platform (e.g., Meta Business Suite).",
        "step3": "Grant 'Read-Only' access to your ad accounts and insights. Dashbal never asks for permission to modify your ads or spend."
      },
      "chartCategories": {
        "intro": "Dashbal offers over 50+ specialized charts across various business domains.",
        "financial": "Financial: P&L, Net Profit, and COGS analysis.",
        "marketing": "Marketing: ROAS, CAC, and multi-channel spend tracking.",
        "operations": "Operations: Fulfillment speed and inventory health.",
        "growth": "Growth: LTV, Retention, and Cohort analysis."
      },
      "billingLimits": {
        "intro": "Each Dashbal plan is designed to scale with your business growth.",
        "pagesTitle": "Page & Chart Quotas",
        "pagesContent": "Free plans allow a limited number of pages and charts per board. Pro plans offer unlimited scalability.",
        "historyTitle": "Data History",
        "historyContent": "View a limited window of historical data on free plans, or full historical access on premium tiers."
      },
      "addingConnectionToBoard": {
        "intro": "After connecting your accounts, you must link them to specific boards to start seeing data in your charts.",
        "stepsTitle": "How to link data:",
        "step1Title": "1. Open Board Connections",
        "step1Content": "Click the Board Name or the Connections icon in the top-right of your board header.",
        "step2Title": "2. Add Connection",
        "step2Content": "In the modal that appears, click 'Add Connection'.",
        "step3Title": "3. Select Source",
        "step3Content": "Choose 'Channel' or 'Money Journal', then select your specific account (e.g., Shopify Store A) from the list.",
        "addConnectionLabel": "Add Connection"
      },
      "talkingToAi": {
        "intro": "Dashbal AI is your personal financial analyst. Instead of digging through charts, you can simply ask questions and get instant insights.",
        "bannerTitle": "Using the AI Banner",
        "bannerContent": "Located at the bottom of every board, the AI Banner is always ready. You can ask things like:",
        "example1": "'Why did my profit drop last week?'",
        "example2": "'Create a waterfall chart for my Q2 marketing spend.'",
        "example3": "'What is my current break-even point?'",
        "example4": "'Compare Shopify sales vs Meta spend.'",
        "workflowTitle": "Validate & Execute",
        "workflowContent": "When you ask AI to modify your board (e.g., 'Add a ROAS chart'), it will prepare a list of proposed actions. You remain in control: review the changes and click 'Validate & Execute' to apply them.",
        "inputPlaceholder": "Type your question here...",
        "activeStatus": "AI ANALYST ACTIVE"
      },
      "planLimits": {
        "intro": "Dashbal AI usage is measured in tokens and conversation quotas. Each plan comes with a weekly allowance.",
        "quotaTitle": "AI Tokens & Quotas",
        "resetTitle": "Weekly Reset",
        "resetContent": "Your AI conversation quota resets every Sunday at 00:00 UTC.",
        "usageTitle": "Tracking Usage",
        "usageContent": "You can view your current usage in the AI History panel (click the clock icon) or your Profile Settings under 'Plan & Usage'."
      },
      "creatingMoneyJournal": {
        "intro": "Money Journals are designed for tracking manual expenses, cash-on-hand, or revenue sources that don't have an API integration.",
        "setupTitle": "Getting Started",
        "setupContent": "Navigate to the 'Money Journal' tab in the Board Explorer. Here you can create journals for different purposes (e.g., 'Office Rent', 'Consulting Revenue')."
      },
      "droppingFiles": {
        "intro": "Stop manual data entry. Simply drop your invoices, receipts, or bank statements into Dashbal and let our AI do the work.",
        "extractionTitle": "AI Data Extraction",
        "engineTitle": "Processing Engine",
        "extractsTitle": "Automatically extracts:",
        "tag1": "Vendor Name",
        "tag2": "Date",
        "tag3": "Total Amount",
        "tag4": "VAT/Taxes",
        "tag5": "Currency"
      },
      "understandingSpecs": {
        "intro": "Specs (Calculated Metrics) allow you to create custom KPIs using our powerful formula engine. You can combine data from different sources into a single metric.",
        "casesTitle": "Example Use Cases",
        "case1": "VAT Calculation: revenue * 0.20",
        "case2": "True Profit: gross_profit - marketing_spend - rent_journal"
      }
    }
  },
  "billing": {
    "banner": {
      "graceTitle": "Action needed: restore your Shopify billing",
      "graceBody_one": "Restore billing within {{count}} day or your account will become read-only.",
      "graceBody_other": "Restore billing within {{count}} days or your account will become read-only.",
      "readOnlyTitle": "Your account is read-only",
      "readOnlyBody_one": "Restore billing to regain full access. Account fully suspended in {{count}} day.",
      "readOnlyBody_other": "Restore billing to regain full access. Account fully suspended in {{count}} days.",
      "reinstallShopify": "Reinstall on Shopify",
      "subscribeWebsite": "Subscribe on the website",
      "reinstallTitle": "Reinstall Dashbal on Shopify",
      "reinstallBody": "You'll be taken to your Shopify admin where you can re-add the Dashbal app to restore billing.",
      "openShopify": "Open Shopify",
      "dismiss": "Dismiss"
    },
    "managedByShopify": {
      "title": "Billed via Shopify",
      "body": "Your subscription is managed in your Shopify admin. Update payment methods, change plans, or cancel from there.",
      "openShopify": "Manage in Shopify"
    },
    "suspended": {
      "title": "Account suspended",
      "body": "Your account is suspended because billing wasn't restored in time. Restore billing on Shopify or start a new subscription on the website to reactivate.",
      "restore": "Restore billing",
      "recoverHint": "Restore billing on Shopify, or start a new subscription on the website."
    }
  }
}